<template>
  <v-container fluid class="grey lighten-5">
    <div class="my-1 mt-0">
      <v-btn icon :to="returnPath">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <span class="display-1 px-3">{{AnalizeTypeCategory}}のお見積依頼{{modeText}}</span>
    </div>

    <v-row dense>
      <v-col :cols="inputCols" dense >
        <v-tabs v-model="selectTab">
          <v-tab
            v-for="title in tabTitles"
            :key="title.id"
            :href="`#${title.id}`"
            @click="changeTab(title.id)"
          >
            {{ title.name }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="selectTab">
          <v-tab-item value="1">
            <v-card outlined flat class="mb-1 pb-1">
              <v-form ref="sampling_form">
                <v-stepper
                  v-model="stepper1"
                  vertical
                  editable
                >
                <v-stepper-step :complete="stepper1 > 1" step="1" editable color="teal darken-1">
                  分析サンプルの油種を選択
                </v-stepper-step>
                <v-stepper-content step="1" class="pt-0">
                  <v-card class="pt-0 mt-2" flat>
                    <v-row dense>
                      <v-col cols="3" md="3" class="align-end" dense> 
                        <v-select
                          v-model="OilTypeCategory"
                          :label="getItemName('オイルの種類')[AnalizeTypeCategory+'label']"
                          :items="oilTypeCategoryList"
                          item-value="Value"
                          item-text="Text"
                          @change="changeOilTypeCategory()"
                          @input="$v.OilTypeCategory.$touch()"
                          :error-messages="OilTypeCategoryErrors"
                          :error="$v.OilTypeCategory.$error"
                          :messages="getItemName('オイルの種類')[AnalizeTypeCategory + 'message']"
                        ></v-select>
                      </v-col>
                      <v-col cols="1" lg="1" md='1' sm='2' xs="2" align-self="center" dense>
                        <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
                      </v-col>

            <v-col cols="10" xl="3" lg="3" md='3' sm='10' xs="10" dense>
                        <v-tooltip top color="grey darken-2">
                          <template v-slot:activator="{ on }">
                            <v-select
                              v-on="on"
                              v-model="OilType"
                              :label="getItemName('オイルの詳細')[AnalizeTypeCategory+'label']"
                              :items="OilTypeList"
                              item-value="Value"
                              item-text="Text"
                              no-data-text="オイルの種類を選択してください。"
                              @change="changeOilType()"
                              @input="$v.OilType.$touch()"
                              @blur="$v.OilType.$touch()"
                              :error-messages="OilTypeErrors"
                              :error="$v.OilType.$error"
                              :message="getItemName('オイルの詳細')[AnalizeTypeCategory+'message']"
                            ></v-select>
                          </template>
                          <span class="wrap-text">{{getItemName('オイルの詳細')[AnalizeTypeCategory+'description']}}</span>
                        </v-tooltip>
                      </v-col>
<!--
                      <template v-if="OilType=='01001001'">
-->
                      <template v-if="isOtherOilType(OilType)">
                        <v-col cols="10" xl="3" lg="3" md='3' sm='10' xs="10" dense >
                        <v-tooltip top color="grey darken-2">
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-on="on"
                              v-model="OilTypeText"
                              :label="getItemName('オイルの詳細（その他）')[AnalizeTypeCategory+'label']"
                              :counter="getItemName('オイルの詳細（その他）')[AnalizeTypeCategory+'counter']"
                              @input="$v.OilTypeText.$touch()"
                              @blur="$v.OilTypeText.$touch()"
                              :error-messages="OilTypeTextErrors"
                              :messages="getItemName('オイルの詳細（その他）')[AnalizeTypeCategory + 'message']"
                            >
                              <template v-slot:prepend-inner v-if="getItemName('オイルの詳細（その他）')[AnalizeTypeCategory+'証明書']">
                                <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                              </template>
                            </v-text-field>
                          </template>
                          <span class="wrap-text">{{getItemName('オイルの詳細（その他）')[AnalizeTypeCategory+'description']}}</span>
                        </v-tooltip>
                        </v-col>
                      </template>
                      <v-col cols="1" lg="1" md='1' sm='2' xs="2" align-self="center" dense>
                        <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
                      </v-col>

                      <template v-if="hasOilProperties">
                        <v-col cols="10" xl="2" lg="3" md='3' sm='10' xs="10" dense>
                          <v-tooltip top color="grey darken-2">
                            <template v-slot:activator="{ on }">
                              <v-select
                                v-on="on"
                                v-model="OilProperty"
                                :label="getItemName('オイルの性質')[AnalizeTypeCategory+'label']"
                                :items="OilPropertyList"
                                item-value="Value"
                                item-text="Text"
                                @input="$v.OilProperty.$touch()"
                                @blur="$v.OilProperty.$touch()"
                                :error-messages="OilPropertyErrors"
                                @change="changeOilProperty()"
                                :messages="getItemName('オイルの性質')[AnalizeTypeCategory + 'message']"
                              >
                                <template v-slot:prepend-inner v-if="getItemName('オイルの性質')[AnalizeTypeCategory+'証明書']">
                                  <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                                </template>
                              </v-select>
                            </template>
                            <span class="wrap-text">{{getItemName('オイルの性質')[AnalizeTypeCategory+'description']}}</span>
                          </v-tooltip>
                        </v-col>
                        <v-col cols="2" xl="1" lg="1" md='1' sm='2' xs="2" align-self="center" dense>
                          <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>
                        </v-col>
                      </template>
                    </v-row>
                      <v-btn color="primary" @click="changeStepper(2)" outlined>次へ</v-btn>
                    </v-card>
                </v-stepper-content>

                <v-stepper-step :complete="stepper1 > 2" step="2" @click="changeStepper(2)" color="teal darken-1">
                  分析・診断依頼内容の入力
                </v-stepper-step>
                <v-stepper-content step="2" class="pt-0">
                  <v-card class="pt-0 mt-2" flat>
                    <v-row dense>               

                      <v-col cols="10" md="5" densa>
                        <v-tooltip top color="grey darken-3">
                          <template v-slot:activator="{ on }">
                            <v-select
                              v-on="on"
                              v-model="AnalizeTypeGroup"
                              @change="changeAnalizeTypeGroup"
                              :label="getItemName('分析方法')[AnalizeTypeCategory+'label']"
                              dense
                              :items="analizeTypeGroupList"
                              item-value="Value"
                              item-text="Text"
                              :error-messages="AnalizeTypeGroupErrors"
                              :error="$v.AnalizeTypeGroup.$error"
                              :message="getItemName('分析方法')[AnalizeTypeCategory+'message']"
                            >
                            </v-select>
                          </template>
                          <span>
                          分析方法を「社定法」か「公定法」かで選択してください。<br><br>
                          <strong>社定法とは...</strong><br>
                          弊社の独自法です。安価で短納期です。<br><br>
                          <strong>公定法とは...</strong><br>
                          公的規格に準拠した方法です。<br>
                          ご依頼時に条件がありますので、事前に営業部へご連絡下さい。<br>
                          ※分析方法で公定法を選択し、公定法分析項目を選択された場合は、上記注意事項に沿ってご依頼ください。
                          </span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="2" md='1' align-self="center" dense>
                        <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
                      </v-col>

                      <v-col cols="10" md="5" densa>
                        <v-tooltip top color="grey darken-2">
                          <template v-slot:activator="{ on }">
                            <v-select
                              v-on="on"
                              v-model="AnalizeType"
                              :label="getItemName('分析区分')[AnalizeTypeCategory+'label']"
                              :items="analizeTypeList"
                              item-value="Value"
                              item-text="Text"
                              no-data-text="分析方法を選択してください。"                    
                              @change="changeAnalizeType"
                              readonly
                              dense
                              :message="getItemName('分析区分')[AnalizeTypeCategory+'message']"
                            >
                            </v-select>
                          </template>
                          <span class="wrap-text">{{getItemName('分析区分')[AnalizeTypeCategory+'description']}}</span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="2" md='1' dense>
                        <v-chip class="ma-2" color="blue" text-color="white" x-small>自 動</v-chip>                    
                      </v-col>

                      <v-col cols="12" md="5" dense>
                        <v-tooltip top color="grey darken-2">
                          <template v-slot:activator="{ on }">
                            <v-select
                              v-on="on"
                              clearable
                              v-model="AnalizeSet" 
                              :label="getItemName('セット分析')[AnalizeTypeCategory+'label']"
                              dense 
                              :items="analizeSetList"  
                              item-value="Value" 
                              item-text="Text" 
                              @change="changeAnalizeSet" 
                              no-data-text="この分析区分にはセット分析はありません"
                              @input="$v.AnalizeSet.$touch()"
                              :error-messages="AnalizeSetErrors"
                              :error="$v.AnalizeSet.$error"
                              :message="getItemName('セット分析')[AnalizeTypeCategory+'message']"
                            >
                              <template v-slot:item="{ item }">
                                <v-checkbox
                                :input-value="AnalizeSet == item.Value"
                                />
                                <v-list-item-content>
                                  <v-list-item-title v-text="item.Text"></v-list-item-title>
                                  <v-list-item-subtitle v-html="item.Description" class="wrap-text"></v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </v-select>
                          </template>
                          <span class="wrap-text">{{getItemName('セット分析')[AnalizeTypeCategory+'description']}}</span>
                        </v-tooltip>
                      </v-col>

<!--
                          v-model="AnalizeItemsInclude"
                          :items="analizeItemListInclude"
-->
                      <v-col cols="12" md="11" v-show="isSelectAnalizeSet" dense>
                        <v-select
                          v-model="analizeSetItems"
                          :items="analizeSetItems"
                          item-value="Value"
                          item-text="Text"
                          label="セットに含まれる分析項目"
                          multiple
                          readonly
                        >
                          <template v-slot:selection="{ item }">
                            <v-chip small>
                              <span>{{ item.Text }}</span>
                            </v-chip>
                          </template>
                        </v-select>
                      </v-col>
                      
                      <v-col cols="12" md="11" dense>
                        <v-tooltip top color="grey darken-2">
                          <template v-slot:activator="{ on }">
                            <v-autocomplete
                              v-on="on"
                              v-model="AnalizeItems"
                              clearable
                              :items="activeAnalizeItemList"
                              item-value="Value"
                              item-text="Text"
                              :label="getItemName('個別分析項目')[AnalizeTypeCategory+'label']"
                              multiple
                              chips
                              no-data-text="分析区分を選択してください。"
                              @change="changeAnalizeItems"
                              @input="$v.AnalizeItems.$touch()"
                              :error-messages="AnalizeItemsErrors"
                              :error="$v.AnalizeItems.$error"
                              :messages="getItemName('個別分析項目')[AnalizeTypeCategory+'message']"
                            >
                              <template v-slot:selection="{ item }">
                                <v-chip
                                  color="green darken-3"
                                  text-color="white"
                                >
                                  <span>{{ item.Text }}</span>
                                </v-chip>
                              </template>
                              <template v-slot:item="{ item }">
                                <v-checkbox
                                :input-value="AnalizeItems.includes(item.Value)"
                                />
                                <v-list-item-content>
                                  <v-list-item-title v-text="item.Text"></v-list-item-title>
                                  <v-list-item-subtitle v-html="item.Description" class="wrap-text"></v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </v-autocomplete>
                          </template>
                          <span class="wrap-text">{{getItemName('個別分析項目')[AnalizeTypeCategory+'description']}}</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>

                    <template v-for="parent of Object.keys(AnalizeItemSub)">
                      <v-row dense class="ml-2" v-bind:key="parent">
                        <v-col cols=12 dense class="mb-0 pb-0">
                          <v-icon color="blue">mdi-information</v-icon>
                          <span class="font-weight-bold">「{{getAnalizeItemName(parent)}}」</span>が選択されました。以下の分析を追加することができます。
                        </v-col>
                        <v-col cols=12 dense class="ml-6 mb-0 pb-0">
                            <v-autocomplete
                              v-model="AnalizeItemSub[parent]" 
                              :items="analizeItemSubList[parent]" 
                              item-value="Value" 
                              item-text="Text" 
                              label="追加項目"
                              class="mb-0 pb-0"
                              @change="changeAnalizeItemSub"
                              :error-messages="AnalizeItemSubError[parent]"
                              multiple
                            >
                              <template v-slot:selection="{ item }">
                                <v-chip
                                  color="green darken-1"
                                  text-color="white"
                                >
                                  <span>{{ item.Text }}</span>
                                </v-chip>
                              </template>
                              <template v-slot:item="{ item }">
                                <v-checkbox
                                :input-value="AnalizeItemSub[parent].includes(item.Value)"
                                />
                                <v-list-item-content>
                                  <v-list-item-title v-text="item.Text"></v-list-item-title>
                                  <v-list-item-subtitle v-html="item.Description" class="wrap-text"></v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </v-autocomplete>
                        </v-col>
                      </v-row>
                    </template>

                    <v-row dense>               
                      <v-col cols="12" dense>
                        <v-checkbox
                          v-model="Opinion"
                          class="agree-text mt-0 mb-0 pa-0" 
                          label="分析・診断依頼内容をジャパン・アナリストスタッフに相談する"
                          :disabled="isOpinionDisabled"
                          :messages="OpinionDescription"
                        ></v-checkbox>
<!--
                        <span v-if="!isOpinionDisabled" class="caption red--text bold mt-0 pt-0">
                          分析項目を選択してみたが念のため相談したい、どのような分析項目を選べばよいかわからない、などご不明点がある場合チェックしてください。<br>
                        </span>
-->
                        <div v-if="Opinion" class="mt-0 pt-0 ml-5">

                          <v-card v-if="getNoticeType!=3" flat outlined class="my-2 pa-2">
                            <div class="mb-2">
                              <v-icon class="mr-1" color="red">mdi-information</v-icon>
                              <span class="caption red--text">ご相談内容にサンプル（オイル）の詳細を記入して下さい。</span>
                            </div>
                            <span v-if="getNoticeType!=3" class="caption bold">
                              お取り扱いに注意が必要なオイルのため、ジャパン・アナリストにて注意事項などご確認させていただいています。<br>
                              サンプル（オイル）の成分、性質によっては分析・診断サービスをご利用頂けない場合ごございます。ご了承ください。<br>
                              <br>
                            </span>
                          </v-card>

                          <span class="caption">
                            お見積り依頼後、当社スタッフよりご連絡いたします。<br>
                            どのような分析診断をご希望ですか？ご相談内容を記入してください。
                          </span>
                          <v-tooltip top color="grey darken-2">
                            <template v-slot:activator="{ on }">
                              <v-textarea v-model="SampleMemo"
                                v-on="on"
                                dense
                                filled
                                counter=64
                                height=100px
                                @input="$v.SampleMemo.$touch()"
                                :error-messages="SampleMemoErrors"
                                :readonly="isOpinionMemoDisabled"
                              ></v-textarea>
                            </template>
                            <span>ジャパン・アナリストスタッフへの相談内容を入力して下さい。</span>
                          </v-tooltip>
                        </div>

                        <div v-if="this.$store.state.isStaff && !this.isCreate">
                          <span class="caption">
                            ジャパン・アナリストからの回答を入力して下さい<br>
                            回答記入後「回答済みにする」をチェックしてください。
                          </span>
                          <v-tooltip top color="grey darken-2">
                            <template v-slot:activator="{ on }">
                              <v-textarea v-model="SampleMessage"
                                v-on="on"
                                dense
                                filled
                                counter=64
                                height=100px
                                class="mb-0"
                                @input="$v.SampleMessage.$touch()"
                                :error-messages="SampleMessageErrors"
                              ></v-textarea>
                            </template>
                            <span>ジャパン・アナリストからの回答を入力してください。</span>
                          </v-tooltip>
                          <v-checkbox
                            v-model="OpinionAnswered"
                            dense
                            class="agree-text mt-0 mb-0 pa-0" 
                            label="回答済みにする"
                          ></v-checkbox>
                        </div>

                        <div v-else-if="SampleMessage">
                          <span class="caption">
                            ジャパン・アナリストからの回答です。<br>
                          </span>
                          {{SampleMessage}}
                        </div>

                      </v-col>
                    </v-row>

                    <v-btn color="primary" @click="changeStepper(3)" outlined>次へ</v-btn>
                    <v-overlay absolute :value="overlayStepper1" opacity="0.8" color="white">
                      <v-progress-circular indeterminate size="64" color="amber"></v-progress-circular>
                    </v-overlay>
                  </v-card>
                </v-stepper-content>

                <v-stepper-step :complete="stepper1 > 3" step="3" @click="changeStepper(3)" color="teal darken-1">
                  サンプル情報の入力
                </v-stepper-step>
                <v-stepper-content step="3" class="pt-0">
                  <v-card class="pt-0 mt-2" flat>
                    <v-row dense>
                      <v-col cols="10" lg="8" md="10" sm='10' xs="10" dense>
                        <v-tooltip top color="grey darken-2">
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-on="on"
                              v-model="SampleName"
                              :label="getItemName('サンプル名')[AnalizeTypeCategory+'label']"
                              dense
                              :counter="getItemName('サンプル名')[AnalizeTypeCategory+'counter']"
                              @input="$v.SampleName.$touch()"
                              :error-messages="SampleNameErrors"
                              :message="getItemName('サンプル名')[AnalizeTypeCategory+'message']"
                            >
                              <template v-slot:prepend-inner v-if="getItemName('サンプル名')[AnalizeTypeCategory+'証明書']">
                                <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                              </template>
                            </v-text-field>
                          </template>
                          <span class="wrap-text">{{getItemName('サンプル名')[AnalizeTypeCategory+'description']}}</span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="2" lg="1" md='1' sm='1' xs="2" align-self="center" dense>
                        <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
                      </v-col>
                    </v-row>

                    <v-row dense>
                      <v-col cols="2" dense>
                        <v-tooltip top color="grey darken-2">
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-on="on"
                              v-model="SameCount"
                              :label="getItemName('サンプル数')[AnalizeTypeCategory+'label']"
                              dense
                              @input="$v.SameCount.$touch()"
                              :error-messages="SameCountErrors"
                              :message="getItemName('サンプル数')[AnalizeTypeCategory+'message']"
                            ></v-text-field>
                          </template>
                          <span class="wrap-text">{{getItemName('サンプル数')[AnalizeTypeCategory+'description']}}</span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="2" lg="1" md='1' sm='1' xs="2" align-self="center" dense>
                        <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
                      </v-col>
                    </v-row>

                    <v-row dense>
                      <v-col cols="6" dense>
                        <v-card flat >
                          <v-radio-group v-model="Filter" class="ml-md-8 ml-2 mt-0" id="card-subject" @change="changeFilter" >
                            <template v-slot:label>
                              <v-tooltip top color="grey darken-2">
                                <template v-slot:activator="{ on }">
                                  <div v-on="on">汚染度（質量法）試験後の<strong>フィルター返却</strong></div>
                                </template>
                                <span class="wrap-text">{{getItemName('フィルター返却')[AnalizeTypeCategory+'description']}}</span>
                              </v-tooltip>
                            </template>
                            <v-radio value="001">
                              <template v-slot:label>
                                <div id="card-subject">不要（0円）</div>
                              </template>
                            </v-radio>
                            <v-radio value="002">
                              <template v-slot:label>
                                <div id="card-subject">必要。<span  id="card-subject2">ラミネート加工 <strong class="black--text">あり（1,700円／検体）</strong></span></div>
                              </template>
                            </v-radio>
                            <v-radio value="003">
                              <template v-slot:label>
                                <div id="card-subject">必要。<span  id="card-subject2">ラミネート加工 <strong class="black--text">なし（600円／検体）</strong></span></div>
                              </template>
                            </v-radio>
                          </v-radio-group>
                        </v-card>
                      </v-col>

                      <v-col cols="6" dense>
                        <v-card flat>
                          <v-radio-group v-model="Surplus" class="ml-md-8 ml-2 mt-0" @change="changeSurplus">
                            <template v-slot:label>
                              <v-tooltip top color="grey darken-2">
                                <template v-slot:activator="{ on }">
                                  <div v-on="on"><strong>着払いで</strong>サンプルの返却</div>
                                </template>
                                <span class="wrap-text">{{getItemName('サンプル返却')[AnalizeTypeCategory+'description']}}</span>
                              </v-tooltip>
                            </template>
                            <v-radio value="0">
                              <template v-slot:label>
                                <div id="card-subject">返却を希望 しない</div>
                              </template>
                            </v-radio>
                            <v-radio value="1">
                              <template v-slot:label>
                                <div id="card-subject">返却を希望 <span  id="card-subject2">（返送には別途手数料が掛ります）</span></div>
                              </template>
                            </v-radio>
                          </v-radio-group>
                          <br>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-btn
                      color="primary"
                      @click="addSample()"
                      :disabled="getAddSampleButtonDisabled()"
                    >
                      {{addSampleButtonText}}
                    </v-btn>
                  </v-card>
                </v-stepper-content>

                </v-stepper>
              </v-form>
              



            </v-card>

          </v-tab-item>



          <v-tab-item value="2">
            <v-form ref="machine_form">
              <v-stepper
                v-model="stepper2"
                vertical
                editable
              >
                <v-stepper-step :complete="stepper2 > 1" step="1" editable color="teal darken-1">
                  マイ機器を選択
                </v-stepper-step>
                <v-stepper-content step="1" class="pt-0">
                  <v-card outlined flat class="mb-1">
                    <v-card-title class="body-1 mb-2 pb-0">
                      {{machineTypeText}}一覧から選択
                    </v-card-title>
                    <v-card-text class="body-1">

                      <v-row v-if="AnalizeTypeCategory=='航空機'" dense>
                        <v-col cols="2" dense class="pb-2">
                          <v-btn class="mx-2 mb-2" color="primary" @click="showAircraftList" :outlined="!getSelectAircraftBtnStyle" small>{{this.getSelectAircraftBtnLabel()}}</v-btn>              
                        </v-col>
                        <v-col cols="2" dense class="pb-2">
                          <v-btn class="mx-2 mb-2" color="primary" @click="closeAircraftList" :outlined="getSelectAircraftBtnStyle" small>すべての装備品から選択</v-btn>              
                        </v-col>

                        <v-col cols="12" dense class="pb-0 mb-0">
                          <v-expand-transition>
                            <div v-if="isShowAircraftList">
                              <div class="body-2 ml-2 mb-2 black--text"><v-icon color="teal" class="mr-1">mdi-numeric-1-box</v-icon>機体を選択してください。</div>
                              <v-row dense>
                                <v-col dense class="pb-0">
                                  <v-data-table
                                    :headers="aircraftListHeaders"
                                    :items="aircrafts"
                                    :items-per-page="aircraftListItemsPerPage"
                                    :page.sync="aircraftListPage"
                                    @page-count="aircraftListPageCount = $event"
                                    :loading="loading"
                                    class="elevation-1 px-2 mb-0 mt-0"
                                    loading-text="読込中"
                                    no-data-text="データがありません。"                    
                                    no-results-text="検索条件に該当するデータがありません。"                  
                                    hide-default-footer
                                    @click:row="selectAircraft"
                                    dense
                                  >
                                  </v-data-table>
                                </v-col>
                              </v-row>
                              <v-row dense>
                                <v-col cols="10"  lg="10" md='8' sm='8' xs="10">
                                  <v-pagination v-model="aircraftListPage" color="amber black--text" light circle :length="aircraftListPageCount"></v-pagination>
                                </v-col>
                                <v-col cols="2"  lg="2"  md='4' sm='4' xs="2">
                                  <v-select
                                    :value="aircraftListItemsPerPage"
                                    :items = "itemsPerPageList"
                                    label="1ページの行数"
                                    @input="aircraftListItemsPerPage = $event"
                                  ></v-select>
                                </v-col>
                              </v-row>
                            </div>
                          </v-expand-transition>
                        </v-col>


                      </v-row>

                      <v-expand-transition>
                        <div v-if="isShowMachineList" dense>
                          <template v-if="AnalizeTypeCategory=='航空機'">
                            <div class="body-2 mt-0 ml-2 mb-2 black--text"><v-icon color="teal" class="mr-1">mdi-numeric-2-box</v-icon>{{machineTypeText}}を選択して下さい。</div>
                          </template>
                          <v-row dense>
                            <v-col dense class="pb-0">
                              <v-text-field
                                v-model="searchMachineKeyword"
                                class="px-2 mb-0 mt-2"
                                prepend-inner-icon="mdi-magnify"
                                placeholder="マイ機器ＩＤで検索"
                                dense
                                filled
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row dense>
                            <v-col dense class="pt-0">
                              <v-data-table
                                :headers="machineListHeaders"
                                :items="machines"
                                :items-per-page="machineListItemsPerPage"
                                :page.sync="machineListPage"
                                @page-count="machineListPageCount = $event"
                                :sort-by="['CustomerMachineID']"
                                :sort-desc="[false]"
                                :loading="loading"
                                class="elevation-1 px-2 mb-0 mt-0"
                                loading-text="読込中"
                                no-data-text="データがありません。"                    
                                no-results-text="検索条件に該当するデータがありません。"                  
                                hide-default-footer
                                @click:row="selectMachine"
                                dense
                              >
                                <template v-slot:[`item.MountedMachineID`]="{ item }">
<!--
                                  {{getAirCraftName(item.MountedMachineID)}}
-->
                                  {{getAirCraftName(item)}}
                                </template>

                              </v-data-table>
                            </v-col>
                          </v-row>
                          <v-row dense>
                            <v-col cols="10"  lg="10" md='8' sm='8' xs="10">
                              <v-pagination v-model="machineListPage" color="amber black--text" light circle :length="machineListPageCount"></v-pagination>
                            </v-col>
                            <v-col cols="2"  lg="2"  md='4' sm='4' xs="2">
                              <v-select
                                :value="machineListItemsPerPage"
                                :items = "itemsPerPageList"
                                label="1ページの行数"
                                @input="machineListItemsPerPage = $event"
                              ></v-select>
                            </v-col>
                          </v-row>
                        </div>
                      </v-expand-transition>

                    </v-card-text>
                  </v-card>
                </v-stepper-content>

                <v-stepper-step :complete="stepper2 > 2" step="2" @click="changeStepper2(2)" color="teal darken-1">
                  分析・診断依頼内容の入力
                </v-stepper-step>
                <v-stepper-content step="2" class="pt-0">
                  <v-card class="pt-0 mt-2" flat>
                    <v-card class="pa-2 mt-0 mb-5" outlined flat>
                      <v-chip small label color="gray" class="label-chip">マイ機器ID</v-chip>{{this.CustomerMachineID}}
                      <v-chip small label color="gray" class="label-chip ml-5">使用機器</v-chip>{{this.MakerID}}／{{this.ModelNumber}}<br>
                      <v-chip small label color="gray" class="label-chip">マイ機器名</v-chip>{{this.MachineName}}<br>
                      <v-chip small label color="gray" class="label-chip">オイルの種類</v-chip>{{this.OilTypeCategoryText}}（{{this.OilTypeText}} {{this.OilPropertyText}}）
                      <v-chip small label color="gray" class="label-chip ml-5">使用オイル</v-chip>{{this.OilmakerID}}／{{this.OilModelNumber}}
                    </v-card>

                    <v-row dense>               
                      <v-col cols="10" md="5" densa>
                        <v-tooltip top color="grey darken-3">
                          <template v-slot:activator="{ on }">
                            <v-select
                              v-on="on"
                              v-model="AnalizeTypeGroup"
                              @change="changeAnalizeTypeGroup"
                              label="分析方法"
                              dense
                              :items="analizeTypeGroupList"
                              item-value="Value"
                              item-text="Text"
                              :error="$v.AnalizeTypeGroup.$error"
                              :error-messages="AnalizeTypeGroupErrors"
                            >
                            </v-select>
                          </template>
                          <span>
                          分析方法を「社定法」か「公定法」かで選択してください。<br><br>
                          <strong>社定法とは...</strong><br>
                          弊社の独自法です。安価で短納期です。<br><br>
                          <strong>公定法とは...</strong><br>
                          公的規格に準拠した方法です。<br>
                          ご依頼時に条件がありますので、事前に営業部へご連絡下さい。<br>
                          ※分析方法で公定法を選択し、公定法分析項目を選択された場合は、上記注意事項に沿ってご依頼ください。
                          </span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="2" md='1' align-self="center" dense>
                        <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
                      </v-col>

                      <v-col cols="10" md="5" densa>
                        <v-tooltip top color="grey darken-2">
                          <template v-slot:activator="{ on }">
                            <v-select
                              v-on="on"
                              v-model="AnalizeType"
                              label="分析区分"
                              :items="analizeTypeList"
                              item-value="Value"
                              item-text="Text"
                              no-data-text="分析方法を選択してください。"                    
                              @change="changeAnalizeType"
                              readonly
                              dense
                            >
                            </v-select>
                          </template>
                          <span class="wrap-text">{{getItemName('分析区分')[AnalizeTypeCategory+'description']}}</span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="2" md='1' dense>
                        <v-chip class="ma-2" color="blue" text-color="white" x-small>自 動</v-chip>                    
                      </v-col>

                      <v-col cols="12" md="5" dense>
                        <v-tooltip top color="grey darken-2">
                          <template v-slot:activator="{ on }">
                            <v-select
                              v-on="on"
                              clearable
                              v-model="AnalizeSet" 
                              :label="getItemName('セット分析')[AnalizeTypeCategory+'label']"
                              dense 
                              :items="analizeSetList"  
                              item-value="Value" 
                              item-text="Text" 
                              @change="changeAnalizeSet" 
                              no-data-text="この分析区分にはセット分析はありません"
                              @input="$v.AnalizeSet.$touch()"
                              :error-messages="AnalizeSetErrors"
                              :error="$v.AnalizeSet.$error"
                              :message="getItemName('セット分析')[AnalizeTypeCategory+'message']"
                            >
                              <template v-slot:item="{ item }">
                                <v-checkbox
                                :input-value="AnalizeSet == item.Value"
                                />
                                <v-list-item-content>
                                  <v-list-item-title v-text="item.Text"></v-list-item-title>
                                  <v-list-item-subtitle v-html="item.Description" class="wrap-text"></v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </v-select>
                          </template>
                          <span class="wrap-text">{{getItemName('セット分析')[AnalizeTypeCategory+'description']}}</span>
                        </v-tooltip>
                      </v-col>

<!--
                          v-model="AnalizeItemsInclude"
                          :items="analizeItemListInclude"
                          isItemsInclude
-->
                      <v-col cols="12" md="11" v-show="isSelectAnalizeSet" dense>
                        <v-select
                          v-model="analizeSetItems"
                          :items="analizeSetItems"
                          item-value="Value"
                          item-text="Text"
                          label="セットに含まれる分析項目"
                          multiple
                          readonly
                        >
                          <template v-slot:selection="{ item }">
                            <v-chip small>
                              <span>{{ item.Text }}</span>
                            </v-chip>
                          </template>
                        </v-select>
                      </v-col>
                      
                      <v-col cols="12" md="11" dense>
                        <v-tooltip top color="grey darken-2">
                          <template v-slot:activator="{ on }">
                            <v-autocomplete
                              v-on="on"
                              v-model="AnalizeItems"
                              clearable
                              :items="activeAnalizeItemList"
                              item-value="Value"
                              item-text="Text"
                              :label="getItemName('個別分析項目')[AnalizeTypeCategory+'label']"
                              multiple
                              chips
                              no-data-text="分析区分を選択してください。"
                              @change="changeAnalizeItems"
                              @input="$v.AnalizeItems.$touch()"
                              :error-messages="AnalizeItemsErrors"
                              :error="$v.AnalizeItems.$error"
                              :messages="getItemName('個別分析項目')[AnalizeTypeCategory + 'message']"
                            >
                              <template v-slot:selection="{ item }">
                                <v-chip
                                  color="green darken-3"
                                  text-color="white"
                                >
                                  <span>{{ item.Text }}</span>
                                </v-chip>
                              </template>
                              <template v-slot:item="{ item }">
                                <v-checkbox
                                :input-value="AnalizeItems.includes(item.Value)"
                                />
                                <v-list-item-content>
                                  <v-list-item-title v-text="item.Text"></v-list-item-title>
                                  <v-list-item-subtitle v-html="item.Description" class="wrap-text"></v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </v-autocomplete>
                          </template>
                          <span class="wrap-text">{{getItemName('個別分析項目')[AnalizeTypeCategory+'description']}}</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>

                    <template v-for="parent of Object.keys(AnalizeItemSub)">
                      <v-row dense class="ml-2" v-bind:key="parent">
                        <v-col cols=12 dense class="mb-0 pb-0">
                          <v-icon color="blue">mdi-information</v-icon>
                          <span class="font-weight-bold">「{{getAnalizeItemName(parent)}}」</span>が選択されました。以下の分析を追加することができます。
                        </v-col>
                        <v-col cols=12 dense class="ml-6 mb-0 pb-0">
                            <v-autocomplete
                              v-model="AnalizeItemSub[parent]" 
                              :items="analizeItemSubList[parent]" 
                              item-value="Value" 
                              item-text="Text" 
                              label="追加項目"
                              class="mb-0 pb-0"
                              @change="changeAnalizeItemSub"
                              :error-messages="AnalizeItemSubError[parent]"
                              multiple
                            >
                              <template v-slot:selection="{ item }">
                                <v-chip
                                  color="green darken-1"
                                  text-color="white"
                                >
                                  <span>{{ item.Text }}</span>
                                </v-chip>
                              </template>
                              <template v-slot:item="{ item }">
                                <v-checkbox
                                :input-value="AnalizeItemSub[parent].includes(item.Value)"
                                />
                                <v-list-item-content>
                                  <v-list-item-title v-text="item.Text"></v-list-item-title>
                                  <v-list-item-subtitle v-html="item.Description" class="wrap-text"></v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </v-autocomplete>
                        </v-col>
                      </v-row>
                    </template>

                    <v-row dense>               
                      <v-col cols="12" dense>
                        <v-checkbox
                          v-model="Opinion"
                          class="agree-text mt-0 mb-0 pa-0" 
                          label="分析・診断依頼内容をジャパン・アナリストスタッフに相談する"
                          :disabled="isOpinionDisabled"
                          :messages="OpinionDescription"
                        ></v-checkbox>
<!--
                        <span v-if="!isOpinionDisabled" class="caption red--text bold mt-0 pt-0">
                          分析項目を選択してみたが念のため相談したい、どのような分析項目を選べばよいかわからない、などご不明点がある場合チェックしてください。<br>
                        </span>
-->
                        <div v-if="Opinion" class="mt-0 pt-0 ml-5">

                          <v-card v-if="getNoticeType!=3" flat outlined class="my-2 pa-2">
                            <div class="mb-2">
                              <v-icon class="mr-1" color="red">mdi-information</v-icon>
                              <span class="caption red--text">ご相談内容にサンプル（オイル）の詳細を記入して下さい。</span>
                            </div>
                            <span v-if="getNoticeType!=3" class="caption bold">
                              お取り扱いに注意が必要なオイルのため、ジャパン・アナリストにて注意事項などご確認させていただいています。<br>
                              サンプル（オイル）の成分、性質によっては分析・診断サービスをご利用頂けない場合ごございます。ご了承ください。<br>
                              <br>
                            </span>
                          </v-card>

                          <span class="caption">
                            お見積り依頼後、当社スタッフよりご連絡いたします。<br>
                            どのような分析診断をご希望ですか？ご相談内容を記入してください。
                          </span>
                          <v-tooltip top color="grey darken-2">
                            <template v-slot:activator="{ on }">
                              <v-textarea v-model="SampleMemo"
                                v-on="on"
                                dense
                                filled
                                counter=64
                                height=100px
                                @input="$v.SampleMemo.$touch()"
                                :error-messages="SampleMemoErrors"
                                :readonly="isOpinionMemoDisabled"
                              ></v-textarea>
                            </template>
                            <span>ジャパン・アナリストスタッフへの相談内容を入力して下さい。</span>
                          </v-tooltip>
                        </div>

                        <div v-if="this.$store.state.isStaff && !this.isCreate">
                          <span class="caption">
                            ジャパン・アナリストからの回答を入力して下さい<br>
                            回答記入後「回答済みにする」をチェックしてください。
                          </span>
                          <v-tooltip top color="grey darken-2">
                            <template v-slot:activator="{ on }">
                              <v-textarea v-model="SampleMessage"
                                v-on="on"
                                dense
                                filled
                                counter=64
                                height=100px
                                class="mb-0"
                                @input="$v.SampleMessage.$touch()"
                                :error-messages="SampleMessageErrors"
                              ></v-textarea>
                            </template>
                            <span>ジャパン・アナリストからの回答を入力してください。</span>
                          </v-tooltip>
                          <v-checkbox
                            v-model="OpinionAnswered"
                            dense
                            class="agree-text mt-0 mb-0 pa-0" 
                            label="回答済みにする"
                          ></v-checkbox>
                        </div>

                        <div v-else-if="SampleMessage">
                          <span class="caption">
                            ジャパン・アナリストからの回答です。<br>
                          </span>
                          {{SampleMessage}}
                        </div>

                      </v-col>
                    </v-row>


                    <v-btn color="primary" @click="changeStepper2(3)" outlined>次へ</v-btn>
                  </v-card>
                </v-stepper-content>

                <v-stepper-step :complete="stepper2 > 3" step="3"  @click="changeStepper2(3)" color="teal darken-1">
                  サンプル情報の入力
                </v-stepper-step>
                <v-stepper-content step="3" class="pt-0">
                  <v-card class="pt-0 mt-2" flat>
                    <v-row dense>
                      <v-col cols="10" lg="8" md="10" sm='10' xs="10" dense>
                        <v-tooltip top color="grey darken-2">
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-on="on"
                              v-model="SampleName"
                              :label="getItemName('サンプル名')[AnalizeTypeCategory+'label']"
                              dense
                              :counter="getItemName('サンプル名')[AnalizeTypeCategory+'counter']"
                              @input="$v.SampleName.$touch()"
                              :error-messages="SampleNameErrors"
                              :message="getItemName('サンプル名')[AnalizeTypeCategory+'message']"
                            >
                              <template v-slot:prepend-inner v-if="getItemName('サンプル名')[AnalizeTypeCategory+'証明書']">
                                <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                              </template>
                            </v-text-field>
                          </template>
                          <span class="wrap-text">{{getItemName('サンプル名')[AnalizeTypeCategory+'description']}}</span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="2" lg="1" md='1' sm='1' xs="2" align-self="center" dense>
                        <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
                      </v-col>
                    </v-row>

                    <v-row dense>
                      <v-col cols="2" dense>
                        <v-tooltip top color="grey darken-2">
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-on="on"
                              v-model="SameCount"
                              label="サンプル数"
                              dense
                              @input="$v.SameCount.$touch()"
                              :error-messages="SameCountErrors"
                            ></v-text-field>
                          </template>
                          <span class="wrap-text">{{getItemName('サンプル数')[AnalizeTypeCategory+'description']}}</span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="2" lg="1" md='1' sm='1' xs="2" align-self="center" dense>
                        <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
                      </v-col>
                    </v-row>

                    <v-row dense>
                      <v-col cols="6" dense>
                        <v-card flat >
                          <v-radio-group v-model="Filter" class="ml-md-8 ml-2 mt-0" id="card-subject" @change="changeFilter" >
                            <template v-slot:label>
                              <v-tooltip top color="grey darken-2">
                                <template v-slot:activator="{ on }">
                                  <div v-on="on">汚染度（質量法）試験後の<strong>フィルター返却</strong></div>
                                </template>
                                <span class="wrap-text">{{getItemName('フィルター返却')[AnalizeTypeCategory+'description']}}</span>
                              </v-tooltip>
                            </template>
                            <v-radio value="001">
                              <template v-slot:label>
                                <div id="card-subject">不要（0円）</div>
                              </template>
                            </v-radio>
                            <v-radio value="002">
                              <template v-slot:label>
                                <div id="card-subject">必要。<span  id="card-subject2">ラミネート加工 <strong class="black--text">あり（1,700円／検体）</strong></span></div>
                              </template>
                            </v-radio>
                            <v-radio value="003">
                              <template v-slot:label>
                                <div id="card-subject">必要。<span  id="card-subject2">ラミネート加工 <strong class="black--text">なし（600円／検体）</strong></span></div>
                              </template>
                            </v-radio>
                          </v-radio-group>
                        </v-card>
                      </v-col>

                      <v-col cols="6" dense>
                        <v-card flat>
                          <v-radio-group v-model="Surplus" class="ml-md-8 ml-2 mt-0" @change="changeSurplus">
                            <template v-slot:label>
                              <v-tooltip top color="grey darken-2">
                                <template v-slot:activator="{ on }">
                                  <div v-on="on"><strong>着払いで</strong>サンプルの返却</div>
                                </template>
                                <span class="wrap-text">{{getItemName('サンプル返却')[AnalizeTypeCategory+'description']}}</span>
                              </v-tooltip>
                            </template>
                            <v-radio value="0">
                              <template v-slot:label>
                                <div id="card-subject">返却を希望 しない</div>
                              </template>
                            </v-radio>
                            <v-radio value="1">
                              <template v-slot:label>
                                <div id="card-subject">返却を希望 <span  id="card-subject2">（返送には別途手数料が掛ります）</span></div>
                              </template>
                            </v-radio>
                          </v-radio-group>
                          <br>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-btn
                      color="primary"
                      @click="addSample()"
                      :disabled="getAddSampleButtonDisabled()"
                    >
                      {{addSampleButtonText}}
                    </v-btn>
                  </v-card>
                </v-stepper-content>
              </v-stepper>
            </v-form>
          </v-tab-item>
        </v-tabs-items>
        <v-card class="pt-0 mt-2" flat>
          <v-chip small label color="gray" class="label-chip">分析料金</v-chip>{{(this.Fee + this.FilterFee) * this.SameCount}} 円
          <v-chip small label color="gray" class="label-chip">分析セット</v-chip>{{this.SetPrice * this.SameCount}} 円
<!--
          <v-chip small label color="gray" class="label-chip">個別分析項目</v-chip>{{(this.Fee - this.SetPrice) * this.SameCount}}（{{this.Price - this.SetPrice}}）
-->
          <v-chip small label color="gray" class="label-chip">個別分析項目</v-chip>{{(this.Fee - this.SetPrice) * this.SameCount}} 円
          <v-chip small label color="gray" class="label-chip">オプション</v-chip>{{this.FilterFee * this.SameCount}} 円
        </v-card>
      </v-col>

      <v-col :cols="cartCols" transition="scroll-y-transition">
        <v-card outlined flat class="pa-0">
<!--
            <div v-show="isShowCart">
              <v-btn text x-small @click="showCart" class="grey--text">
                <span>見積依頼を閉じる</span>
                <v-icon>mdi-arrow-collapse-right</v-icon>
              </v-btn>
            </div>
            <div v-show="!isShowCart">
              <v-btn text x-small @click="showCart" class="grey--text">
                <v-icon>mdi-arrow-collapse-left</v-icon>
                <span>見積依頼を開く</span>
              </v-btn>
            </div>
-->
          <v-toolbar dense flat class="white--text ma-0 pl-2 py-0" color="grey darken-3">お見積り内容
            <v-spacer></v-spacer>
            <v-chip small label color="gray" class="label-chip px-2 ml-2">サンプル数</v-chip>{{selectedSamples.length}}
            <template v-if="this.$store.state.isStaff"><v-chip small label color="gray" class="label-chip px-2 ml-2">相談回答済</v-chip>{{AnsweredCount}}/{{OpinionCount}}</template>
            <template v-else><v-chip small label color="gray" class="label-chip px-2 ml-2">見積相談</v-chip>{{OpinionCount}}</template>
            <v-chip small label color="gray" class="label-chip px-2 ml-2">サンプル返却</v-chip>{{SurplusCount}}
          </v-toolbar>


<!--
          <v-tooltip top color="grey darken-2">
            <template v-slot:activator="{ on }">
              <v-text-field
                v-on="on"
                v-model="ApplicationName"
                label="案件名"
                dense
                counter=50
                class="mx-4 mt-5"
                @input="$v.ApplicationName.$touch()"
                :error-messages="ApplicationNameErrors"
              ></v-text-field>
            </template>
            <span>お見積り依頼を識別する名称を入力できます。</span>
          </v-tooltip>
-->

          <v-list class="cart-list mt-0 pa-0" style="max-height: 550px;" color="grey lighten-3" dense nav>
          <div v-if="!isCreate" class="mr-2 subtitle-1 pa-0"><v-chip label color="gray" class="label-chip mt-2 ml-3 mb-1">ご担当者様</v-chip>{{ OrdererName }} 様</div>

            <template v-for="(item, index) in selectedSamples">
              <v-list-item
                :key="index"
                v-show="isShowCart"
              >
                <v-list-item-content class="body-2 px-0 pt-1">
                    <v-card outlined flat class="pa-0">
                      <v-chip v-if="item.id==editid" label outlined color="blue" class="white--text mt-1 ml-2">編 集 中</v-chip>
                      <v-chip v-if="item.id==viewid" label outlined color="green" class="white--text mt-1 ml-2">参 照 中</v-chip>
                      <v-chip v-if="item.Status=='quoteReturn'" label color="amber" class="black--text mt-1 ml-2">確認/回答済み</v-chip>
                      <v-chip v-if="item.delete" label color="red" class="white--text mt-1 ml-2">削除されました</v-chip>
                      <v-chip v-if="item.update" label color="yellow" class="black--text mt-1 ml-2">変更されました</v-chip>
                      <v-chip v-if="item.insert" label color="blue" class="white--text mt-1 ml-2">追加されました</v-chip>

                      <v-app-bar
                        flat
                        color="rgba(0, 0, 0, 0)"
                        class="ma-0 pa-0"
                        max-height="32px"
                      >
                        <v-toolbar-title class="text-h4 black--text pl-0 mt-0">
                          <v-chip v-if="item.OilTypeCategoryText=='潤滑油'" small color="green" class="white--text mt-0 mr-2">{{ item.OilTypeCategoryText }}</v-chip>
                          <v-chip v-else-if="item.OilTypeCategoryText=='燃料'" small color="yellow" class="black--text mr-2">{{ item.OilTypeCategoryText }}</v-chip>
                          <v-chip v-else-if="item.OilTypeCategoryText=='グリス'" small color="blue" class="black--text mr-2">{{ item.OilTypeCategoryText }}</v-chip>
                          {{ item.Name }}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-tooltip top color="grey" v-if="!getSampleButtonDisabled(item).check">
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on"
                              fab
                              x-small
                              color="grey darken-3"
                              outlined
                              rounded
                              class="mr-1"
                              :disabled="getSampleButtonDisabled(item).check"
                              @click="viewSample(item)">
                              <v-icon >mdi-check</v-icon>
                            </v-btn>
                          </template>
                          <span>このサンプルの見積依頼内容を確認します</span>
                        </v-tooltip>


                        <v-tooltip top color="grey darken-2">
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on"
                              fab
                              x-small
                              color="grey darken-3"
                              outlined
                              rounded
                              class="mr-1"
                              :disabled="getSampleButtonDisabled(item).edit"
                              @click="editSample(item)">
                              <v-icon >mdi-lead-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>このサンプルの見積依頼内容を編集します</span>
                        </v-tooltip>

                        <v-tooltip top color="grey darken-2">
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on"
                              fab
                              x-small
                              color="grey darken-3"
                              outlined
                              rounded
                              class="mr-1"
                              :disabled="getSampleButtonDisabled(item).copy"
                              @click="copySample(item)">
                              <v-icon >mdi-content-copy</v-icon>
                            </v-btn>
                          </template>
                          <span>このサンプルの見積依頼内容をコピーします</span>
                        </v-tooltip>

                        <v-tooltip top color="grey darken-2">
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on"
                              fab
                              x-small
                              color="grey darken-3"
                              outlined
                              rounded
                              class="mr-1"
                              :disabled="getSampleButtonDisabled(item).delete"
                              @click="delSample(item)">
                              <v-icon >mdi-delete</v-icon>
                            </v-btn>
                          </template>
                          <span>このサンプルを見積依頼から削除します</span>
                        </v-tooltip>
                      </v-app-bar>

                      <v-card-subtitle class="pb-1">
                        <v-chip v-if="item.isHazardousMaterials == 1" x-small color="red" class="white--text ml-2">取扱注意</v-chip>
                        {{ item.OilTypeText }}
                      </v-card-subtitle>
                      <v-card-title class="pt-0 pb-0 mb-0">
                        <v-chip small label color="gray" class="label-chip">分析セット</v-chip><div class="mr-2 subtitle-1">{{ item.AnalizeTypeGroupName }}</div> <div v-if="item.AnalizeSet" class="subtitle-1">{{ item.AnalizeSetName }}</div><div v-else class="subtitle-1">（分析セット指定なし）</div>
                      </v-card-title>
                      <v-card-title class="pt-0 pb-0 mb-0">
                        <v-chip small label color="gray" class="label-chip">サンプル数</v-chip><div class="subtitle-1">{{ item.SameCount }} サンプル</div>
                      </v-card-title>
                      <v-card-title class="pt-0 pb-0 mb-0">
                        <v-chip small label color="gray" class="label-chip">分析料金</v-chip><div class="subtitle-1">{{ Number(Number(item.Fee) * Number(item.SameCount)).toLocaleString() }} 円（税抜き）</div>
                      </v-card-title>

<!--                              v-model="item.AnalizeItemsInclude"
                              :items="item.analizeItemListInclude"
-->

                      <v-card-text class="mb-0">
                        <v-row v-if="item.AnalizeSet" class="mb-0" dense>
                          <v-col cols="12" md="12" dense>
                            <v-select
                              v-model="item.analizeSetItems"
                              :items="item.analizeSetItems"
                              item-value="Value"
                              item-text="Text"
                              label="次の分析項目がセットに含まれます"
                              multiple
                              readonly
                              class="mt-2 pb-0"
                            >
                              <template v-slot:selection="{ item }">
                                <v-chip small color="gray">
                                  <span>{{ item.Text }}</span>
                                </v-chip>
                              </template>
                            </v-select>
                          </v-col>
                        </v-row>

<!--
                        <v-row v-if="item.AnalizeItems.length>0" dense>
                          <v-col cols="12" md="12" dense>
                                <v-select
                                  v-model="item.AnalizeItems"
                                  :items="item.analizeItemList"
                                  item-value="Value"
                                  item-text="Text"
                                  label="次の分析項目が選択されています"
                                  multiple
                                  readonly
                                  class="mt-0 black--text"
                                >
                                  <template v-slot:selection="{ item }">
                                    <v-chip
                                      small
                                      color="green darken-3"
                                      text-color="white"
                                    >
                                      <span>{{ item.Text }}</span>
                                    </v-chip>
                                  </template>
                                </v-select>
                          </v-col>
                        </v-row>
-->
                        <template v-if="item.allAnalizeItemNames">
                          <v-row dense>
                            <v-col cols="12" md="12" dense>
                              <div class="caption mt-0">次の分析項目が選択されています</div>
                              <template v-for="(item, index) in item.allAnalizeItemNames">
                                <v-chip small color="green darken-3" class="white--text ml-2 mb-1" :key="index"> {{item}}</v-chip>
                              </template>
                            </v-col>
                          </v-row>
                        </template>


                        <v-row dense>
                          <v-col cols=12 dense>
                            <v-chip small label color="gray" class="label-chip">オプション</v-chip>
                            <v-chip v-if="item.Opinion==true" small label color="red" class="white--text ml-0 mr-2 mb-1">{{ getOpinionString(item.Opinion )}}</v-chip>
                            <v-chip v-if="item.Filter!='001'" small outlined label color="green darken-3" class="mr-2 mb-1">{{ getFilterString(item.Filter) }}</v-chip>
                            <v-chip v-if="item.Surplus!='0'"  small outlined label color="green darken-3" class="mr-2 mb-1">{{ getSurplusString(item.Surplus) }}</v-chip>
                          </v-col>
                        </v-row>

                        <v-card-subtitle v-if="item.Memo" class="mt-3 mb-0 pa-0">分析・診断依頼についてのご相談内容</v-card-subtitle>
                        <v-card v-if="item.Memo" flat class="mt-0 pa-1">
                          <strong style="white-space:pre-wrap; word-wrap:break-word;">
                            {{item.Memo}}
                          </strong>
                        </v-card>
                        <v-card-subtitle v-if="item.Message" class="mt-3 mb-0 pa-0">ジャパン・アナリストからの回答</v-card-subtitle>
                        <v-card v-if="item.Message" flat class="mt-0 pa-1">
                          <strong style="white-space:pre-wrap; word-wrap:break-word;">
                            {{item.Message}}
                          </strong>
                        </v-card>
                      </v-card-text>
                    </v-card>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-card>

          <div v-show="isShowCart" class="mt-3">
            <v-row dense>
              <v-col cols='12' dense>
                <v-chip small label color="teal darken-1" text-color="white" class="label-chip px-2 mx-1">分析料金合計</v-chip>
                <span class="subtitle-1 ml-1">{{ TotalFee.toLocaleString() }} 円（税抜き）</span>
                <span v-if="SurplusCount > 0" class="ml-1 subtitle-2">（サンプル返却手数料含む）</span>
              </v-col>

              <v-col cols='12' dense>
                <v-tooltip top color="grey darken-1">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="ApplicationName"
                      :label="getItemName('見積り案件名')[AnalizeTypeCategory+'label']"
                      counter=50
                      class="pt-2"
                      @input="$v.ApplicationName.$touch()"
                      :error-messages="ApplicationNameErrors"
                      :messages="getItemName('見積り案件名')[AnalizeTypeCategory + 'message']"
                    ></v-text-field>
                  </template>
                  <span class="wrap-text">{{getItemName('見積り案件名')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>
              </v-col>

              <v-col cols='12' dense>
                <v-tooltip top color="grey darken-1">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      rounded 
                      block 
                      color="amber darken-1" 
                      class="mt-2"
                      @click="validationQuote()"
                      :disabled="getCreateQuoteButtonDisabled()"
                      data-createQuote>
                      <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
                      見積依頼{{modeText}}内容を確認する
                    </v-btn>
                  </template>
                  <span>クリックすると、見積依頼{{modeText}}内容の確認画面が開きます</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </div>

      </v-col>

    </v-row>

    <v-dialog
      v-model="isConfirmed"
      persistent
      max-width="90%"
    >
      <v-card class="px-3 py-2">
        <v-card-title v-if="quoteReturnAlert == 0" class="headline">
          <v-icon class="mr-1" color="primary" large>mdi-information-outline</v-icon>
            ご依頼{{modeText}}内容をご確認ください
        </v-card-title>
        <v-card-text v-if="quoteReturnAlert == 0">
           下記のお見積り依頼内容をご確認のうえ「お見積りを依頼する」ボタンをクリックしてください<br>
           ※グレーの分析項目は分析セットに含まれる分析項目です。緑の分析項目は個別に追加された分析項目です。
         </v-card-text>

        <v-card-title v-if="quoteReturnAlert == 1" class="headline">
          <v-icon class="mr-1" color="red" large>mdi-information</v-icon>
           分析診断内容のご相談がすべて回答されました。<br>
        </v-card-title>
        <v-card-text v-if="quoteReturnAlert == 1" >
           お見積り依頼を発行した得意先担当者様に通知メールが送信されます。<br>
         </v-card-text>

        <v-card-title v-if="quoteReturnAlert == 2" class="headline">
          <v-icon class="mr-1" color="primary" large>mdi-information</v-icon>
           分析診断内容のご相談が残っています。<br>
        </v-card-title>
        <v-card-text v-if="quoteReturnAlert == 2">
           すべてのご相談に回答されるまで得意先担当者様に通知されません。<br>
           <br>
           分析診断内容を相談を希望されているサンプルがすべて<b>「回答済みにする」</b>になるまで正式な回答とみなされません。<br>
           すべて回答済みである場合は「回答済みにする」がチェックされているか確認してください。<br>
        </v-card-text>

            <v-card outlined flat class="mb-3">
              <div class="teal darken-1 pa-2 mt-0 mb-1 white--text">お見積り依頼内容</div>
              <v-row class="pa-2 mt-0" dense>
                <v-col cols="12" lg="12" md="12" sm="12" xs="12" dense>

                  <v-data-table
                    :headers="confirmSamplesHeaders"
                    :items="selectedSamples"
                    v-model="selectedSamples"
                    :sort-by="['SampleID']"
                    :sort-desc="[false]"
                    :page.sync="page"
                    :items-per-page=100
                    :loading="loading"
                    class="elevation-1"
                    loading-text="読込中"
                    no-data-text="分析依頼サンプルを追加して下さい。"
                    hide-default-footer
                    dense
                    :expanded="selectedSamples"
                    @page-count="pageCount = $event"
                    @input="$v.selectedSamples.$touch()"
                  >
                    <template v-slot:[`item.Status`]="{ item }">
                      <v-chip v-if="item.insert==true" label color="blue" class="ml-2 mt-1 mb-1 white--text">追 加</v-chip>
                      <v-chip v-else-if="item.update==true" label color="yellow" class="ml-2 mt-1 mb-1 black--text">更 新</v-chip>
                      <v-chip v-else-if="item.delete==true" label color="red" class="ml-2 mt-1 mb-1 white--text">削 除</v-chip>
                    </template>
                    <template v-slot:[`item.OilTypeText`]="{ item }">
                      {{item.OilTypeCategoryText}}（{{ item.OilTypeText }}）
                    </template>
                    <template v-slot:[`item.AnalizeSetName`]="{ item }">
                      <div v-if="item.AnalizeSetName">{{item.AnalizeTypeGroupName}}／{{ item.AnalizeSetName }}</div>
                      <div v-else>{{item.AnalizeTypeGroupName}}（分析セット指定なし）</div>
                    </template>
                    <template v-slot:[`item.Options`]="{ item }">
                      <v-chip v-if="item.Opinion==true"   small label color="red" class="ml-2 mt-1 mb-1 white--text">{{ getOpinionString(item.Opinion) }}</v-chip>
                      <v-chip v-show="item.Filter!='001'" small outlined label class="ml-2 mt-1 mb-1" color="green darken-3">{{ getFilterString(item.Filter) }}</v-chip>
                      <v-chip v-show="item.Surplus!='0'"  small outlined label class="ml-2 mt-1 mb-1" color="green darken-3">{{ getSurplusString(item.Surplus) }}</v-chip>
                    </template>

                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length">
                        <v-chip v-show="item.analizeSetItems" v-for="a of item.analizeSetItems" v-bind:key="a.Value" class="ml-4 mt-1 mb-1 black--text" small color="grey lighten-1">{{ a.Text }}</v-chip>
                        <v-chip v-show="item.AnalizeItemNames"    v-for="a of item.AnalizeItemNames"    v-bind:key="a.Value" class="ml-4 mt-1 mb-1 white--text" small color="green darken-3">{{ a.Text }}</v-chip>
<!--
                        <v-chip v-show="item.AnalizeItemNames"    v-for="a of item.AnalizeItemNames"    v-bind:key="a" class="ml-4 mt-1 mb-1 white--text" small color="green darken-3">{{ a }}</v-chip>
-->
                      </td>
                    </template>
                  </v-data-table>

<!--
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="body-5" width="10%">試料番号</th>
                          <th class="body-5" width="10%">定期登録番号</th>
                          <th class="body-5" width="15%">使用機器名</th>
                          <th class="body-5" width="15%">オイルメーカー</th>
                          <th class="body-5" width="15%">オイル名</th>
                          <th class="body-5" width="10%">採取日</th>
                          <th class="body-5" width="15%">オイル使用時間</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr dense v-for="item of selectedSamples" v-bind:key="item.id">
                          <td class="body-5">
                            {{ item.CustomerOrderNumber}}-{{ numSampleID(item.SampleID) }}
                          <td class="body-5">
                            {{ item.CustomerMachineID }}
                          </td>
                          <td class="body-5">
                              {{ item.Name }}
                          </td>
                          <td class="body-5">
                              {{ item.OilmakerID }}
                          </td>
                          <td class="body-5">
                              {{ item.OilModelNumber }}
                          </td>
                          <td class="body-5">
                              {{ item.SamplingAt }}
                          </td>
                          <td class="body-5">
                              {{ item.OilUsageTime }} {{ item.OilUsageTimeUnitText }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
-->

                </v-col>
              </v-row>
          </v-card>

        <v-card-actions>
            <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            outlined
            rounded
            elevation="2"
            class="mr-3"
            @click="isConfirmed = false"
          >
            キャンセル
          </v-btn>
          <v-tooltip top color="grey darken-2">
            <template v-slot:activator="{ on }">
              <v-btn 
              v-on="on"
              rounded 
              color="amber darken-1" 
              @click="createQuote()" 
              :disabled="processing"
              data-createQuote 
              class="px-2"
              >
                <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
                  お見積りを依頼する
              </v-btn> 
            </template>
            <span>お見積依頼を登録します</span>
          </v-tooltip>


        </v-card-actions>
      </v-card>
    </v-dialog>

  <!-- dialogコール -->
  <appDialog :failureUrl="failureUrl" ref="isFailured"></appDialog>
  <sucDialog :successText="successText" :successUrl="successUrl" ref="isSuccessed"></sucDialog>
  <sucDialog4Staff :successText="successText" :successUrl="successUrl" ref="isSuccessed4Staff"></sucDialog4Staff>
  <valiDialog :valiErrorText="valiErrorText" ref="isErrored"></valiDialog>
  <loading-dialog :message="loadingMessage" :progressMessages="progressMessages" ref="isLoading"></loading-dialog>
  <loading-dialog2 message="読み込み処理中" ref="isLoading2"></loading-dialog2>

    </v-container>
</template>

<script>
import { API, graphqlOperation} from "aws-amplify"
import { createApplication,  } from "../graphql/mutations"
import { updateApplication,  } from "../graphql/mutations"
import { createSample } from "../graphql/mutations"
import { updateSample } from "../graphql/mutations"
import { deleteSample } from "../graphql/mutations"
import { getApplication, samplesByApplication } from '../graphql/queries'
//import { officeByCompany, } from '../graphql/queries'
//import { companyByKey, } from '../graphql/queries'
//import { sortedAnalizeSetByType, } from '../graphql/queries'
//import { sortedAnalizeItemByType, } from '../graphql/queries'
//import { analizeItemByCompany, } from '../graphql/queries'
//import { analizeTypeByGroup, } from '../graphql/queries'
//import { analizeTypeGroupByCategory, } from '../graphql/queries'
import { fetchAllMachineByOffice } from '../utils/utils'
import { getMachine, } from '../graphql/queries'


import validations from '../utils/validations.js'
import { required, maxLength } from 'vuelidate/lib/validators'
import isFailured from "../components/failureDialog.vue"
import valiErrored from "../components/validateErrorDialog.vue"
import entSuccessed from "../components/successQuoteDialog.vue"
import entSuccessed4staff from "../components/successQuoteDialog4Staff.vue"
import Loading from "../components/Loading.vue"
import Loading2 from "../components/Loading2.vue"
//import { helpers } from 'vuelidate/lib/validators'
import generateUuid  from '../utils/generateUuid.js'
//const alpha_dash = helpers.regex('alpha_dash', /^[a-zA-Z0-9_ -]*$/)
//const eneosOrderNumber = helpers.regex('eneosOrderNumber', /^[0-9]{2}[A-Z]{2}[0-9]{3,4}$/)
import mixin  from '../utils/mixin.js'
import utils  from '../utils/utils.js'

function isAnalizeSet (value, vm) {
  if (vm.AnalizeItems == undefined) {
    return true
  }

  if((vm.Opinion == false) || (vm.OpinionAnswered == true)){
    if (!vm.AnalizeSet&&!vm.AnalizeItems.length) {
      return false
    } else {
      return true
    }
  }else {
    return true
  }
}
function hasHazardousMaterialsDetail (vaslue, vm) {
  if (vm.isHazardousMaterials == "1") {
    if(!vm.HazardousMaterialsDetail) {
      return false
    }
  }
  return true
}
function hasOpinionRequestDetail (vaslue, vm) {
  if (vm.Opinion == true) {
    if(!vm.SampleMemo) {
      return false
    }
  }
  return true
}
function hasOpinionAnswer (vaslue, vm) {
  if (vm.OpinionAnswered == true) {
    if(!vm.SampleMessage) {
      return false
    }
  }
  return true
}
function requiredOilProperty(value) {
  if(this.hasOilProperties && !value) {
    return false
  }
  return true
}

function analizeItemRelations() {
/*
// 追加項目は必須でないためエラーなし
  console.log("analizeItemRelations:", this.$v.AnalizeItems)
  this.AnalizeItemSubError = {}
  for (var parentItem of Object.keys(this.AnalizeItemSub)) {
    if(this.AnalizeItemSub[parentItem].length==0) {
      this.AnalizeItemSubError[parentItem] = "追加する分析項目を選択してください"
      return false
    }
  }
*/
  return true
}
// (社)汚染度(計数法・SAE)Table1(PCSAE1) 関連チェック1
// (社)汚染度(計数法・SAE)Table2(PCSAE2) 関連チェック1
function analizeItemRelationPCSA1(value, vm) {
  // resetしたときにイベント発火→undefinedなのでエラーになる
  if(this.AnalizeTypeGroup == undefined) {
    return true
  }
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("PCSA1M")) {
    return vm.AnalizeItems.includes("PCISOM") || vm.analizeSetItems.some(item => item.Value == "PCISOM")
  }

  if(vm.AnalizeItems.includes("PCSA2M")) {
    return vm.AnalizeItems.includes("PCISOM") || vm.analizeSetItems.some(item => item.Value == "PCISOM")
  }

  return true
}

// (社)汚染度(計数法・SAE)Table1(PCSAE1) 関連チェック2
// (社)汚染度(計数法・SAE)Table2(PCSAE2) 関連チェック2
function analizeItemRelationPCSA2(value, vm) {
  let condition1 = 0
  // resetしたときにイベント発火→undefinedなのでエラーになる
  if(this.AnalizeTypeGroup == undefined) {
    return true
  }
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }

  condition1 += vm.AnalizeItems.includes("PCSA1M") ? 1 : 0
  condition1 += vm.AnalizeItems.includes("PCSA2M") ? 1 : 0
  if(condition1 >= 2) {
    return false
  }

  return true
}

// 粘度指数(VI__J) 関連チェック
function analizeItemRelationVI___J(value, vm) {
  console.log("analizeItemRelationVI___J:", vm.AnalizeItems)
  if(vm.AnalizeItems.includes("VI___J")) {
    let condition1 = 0
    condition1 += vm.AnalizeItems.includes("V40__J") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("V100_J") ? 1 : 0

    condition1 += this.analizeSetItems.filter(item => item.Value  == "V40__J").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "V100_J").length > 0 ? 1 : 0

    if(condition1 >= 2) {
      return true
    }
    return false
  }
  return true
}

// ｾﾀﾝ指数(CETINJ) 関連チェック
function analizeItemRelationCETINJ(value, vm) {
  console.log("analizeItemRelationCETINJ:", vm.AnalizeItems)
  // resetしたときにイベント発火→undefinedなのでエラーになる
  if(this.AnalizeTypeGroup == undefined) {
    return true
  }
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("CETINJ")) {
    let condition1 = 0
    condition1 += vm.AnalizeItems.includes("DIST_M") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("SG___J") ? 1 : 0

    condition1 += this.analizeSetItems.filter(item => item.Value  == "DIST_M").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "SG___J").length > 0 ? 1 : 0

    if(condition1 >= 2) {
      return true
    }
    return false
  }
  return true
}

// 総発熱量（計算値）(GCVC_J) 関連チェック
function analizeItemRelationGCVC_J(value, vm) {
  console.log("analizeItemRelationGCVC_J:", vm.AnalizeItems)
  // resetしたときにイベント発火→undefinedなのでエラーになる
  if(this.AnalizeTypeGroup == undefined) {
    return true
  }
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("GCVC_J")) {
    let condition1 = 0
    let condition2 = 0
    condition1 += vm.AnalizeItems.includes("KF2__M") ? 1 : 0
    condition2 += vm.AnalizeItems.includes("S4___M") ? 1 : 0
    condition2 += vm.AnalizeItems.includes("S2___J") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("ASH__M") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("SG___J") ? 1 : 0

    condition1 += this.analizeSetItems.filter(item => item.Value  == "KF2__M").length > 0 ? 1 : 0
    condition2 += this.analizeSetItems.filter(item => item.Value  == "S4___M").length > 0 ? 1 : 0
    condition2 += this.analizeSetItems.filter(item => item.Value  == "S2___J").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "ASH__M").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "SG___J").length > 0 ? 1 : 0
    if(condition1 >= 3) {
      if(condition2 >= 1) {
        return true
      }
    }
    return false
  }
  return true
}

// 真発熱量（計算値）(NCVC_J)関連チェック
function analizeItemRelationNCVC_J(value, vm) {
  // resetしたときにイベント発火→undefinedなのでエラーになる
  if(this.AnalizeTypeGroup == undefined) {
    return true
  }
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("NCVC_J")) {
    let condition1 = 0
    let condition2 = 0
    condition1 += vm.AnalizeItems.includes("KF2__M") ? 1 : 0
    condition2 += vm.AnalizeItems.includes("S4___M") ? 1 : 0
    condition2 += vm.AnalizeItems.includes("S2___J") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("ASH__M") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("SG___J") ? 1 : 0

    condition1 += this.analizeSetItems.filter(item => item.Value  == "KF2__M").length > 0 ? 1 : 0
    condition2 += this.analizeSetItems.filter(item => item.Value  == "S4___M").length > 0 ? 1 : 0
    condition2 += this.analizeSetItems.filter(item => item.Value  == "S2___J").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "ASH__M").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "SG___J").length > 0 ? 1 : 0
    if(condition1 >= 3) {
      if(condition2 >= 1) {
        return true
      }
    }
    return false
  }
  return true
}

// 顕微鏡写真(PHO__X)関連チェック
function analizeItemRelationPHO__X(value, vm) {
  console.log("analizeItemRelationPHO__X:", vm.AnalizeItems)
  // resetしたときにイベント発火→undefinedなのでエラーになる
  if(this.AnalizeTypeGroup == undefined) {
    return true
  }
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("PHO__X")) {
    let condition1 = 0
    
    condition1 += vm.AnalizeItems.includes("PW___M") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW01_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW10_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW45_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW80_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW12_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW50_X") ? 1 : 0

    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW___M").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW01_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW10_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW45_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW12_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW50_X").length > 0 ? 1 : 0
    if(condition1 >= 1) {
      return true
    }
    return false
  }
  return true
}

// 写真２枚(PHO2_X)関連チェック
function analizeItemRelationPHO2_X(value, vm) {
  // resetしたときにイベント発火→undefinedなのでエラーになる
  if(this.AnalizeTypeGroup == undefined) {
    return true
  }
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("PHO2_X")) {
    let condition1 = 0
    
    condition1 += vm.AnalizeItems.includes("PW___M") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW01_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW10_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW45_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW80_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW12_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW50_X") ? 1 : 0

    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW___M").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW01_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW10_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW45_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW12_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW50_X").length > 0 ? 1 : 0
    if(condition1 >= 1) {
      return true
    }
    return false
  }
  return true
}

// 酸溶解・金属元素(SOAP6X)関連チェック
function analizeItemRelationSOAP6X(value, vm) {
  // resetしたときにイベント発火→undefinedなのでエラーになる
  if(this.AnalizeTypeGroup == undefined) {
    return true
  }
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("SOAP6X")) {
    let condition1 = 0
    
    condition1 += vm.AnalizeItems.includes("PW___M") ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW___M").length > 0 ? 1 : 0

    if(condition1 >= 1) {
      return true
    }
    return false
  }
  return true
}

// 灰化・酸溶解・金属分析(SOAP5X)関連チェック
function analizeItemRelationSOAP5X(value, vm) {
  // resetしたときにイベント発火→undefinedなのでエラーになる
  if(this.AnalizeTypeGroup == undefined) {
    return true
  }
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("SOAP5X")) {
    let condition1 = 0
    
    condition1 += vm.AnalizeItems.includes("PW___M") ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW___M").length > 0 ? 1 : 0

    if(condition1 >= 1) {
      return true
    }
    return false
  }
  return true
}

// 環分析n-d-M法(RA___Z) 関連チェック
function analizeItemRelationRA___Z(value, vm) {
  // resetしたときにイベント発火→undefinedなのでエラーになる
  if(this.AnalizeTypeGroup == undefined) {
    return true
  }
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("RA___Z")) {
    let condition1 = 0
    let condition2 = 0
    condition1 += vm.AnalizeItems.includes("SG___J") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("RID__J") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("V100_J") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("V40__J") ? 1 : 0
    condition2 += vm.AnalizeItems.includes("S4__M") ? 1 : 0
    condition2 += vm.AnalizeItems.includes("S2___J") ? 1 : 0

    condition1 += this.analizeSetItems.filter(item => item.Value  == "SG___J").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "RID__J").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "V100_J").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "V40__J").length > 0 ? 1 : 0
    condition2 += this.analizeSetItems.filter(item => item.Value  == "S4__M").length > 0 ? 1 : 0
    condition2 += this.analizeSetItems.filter(item => item.Value  == "S2___J").length > 0 ? 1 : 0
    if(condition1 >= 4) {
      if(condition2 >= 1) {
        return true
      }
    }
    return false
  }
  return true
}


function alphaNumPlus(value) {
  if(value) {
    // 半角英数（＋ハイフン、ドット、アンダースコア）のみ許可
//  if(!value.match(/^[0-9a-zA-Z/.-]*$/)){
    if(!value.match(/^[0-9a-zA-Z/.\s_-]*$/)){
        return false;
    }
  }
  return true
}

export default {
  beforeRouteLeave (to, from, next) {
    if (this.$v.$anyDirty&&!this.isPageMove) {
      let answer = window.confirm("編集中のデータがあります。本当にこのページから離れますか？")
      if (answer) {
        next()
      } else {
        next(false)
      }
    } else {
      if(this.isPageMove) {
        let answer = window.confirm("登録していない見積依頼サンプル情報があります。本当にこのページから離れますか？")
        if (answer) {
          next()
        } else {
          next(false)
        }
      }else {
       next()
      }
    }
  },


  mixins:[validations, generateUuid, mixin, utils],
  head: {
    title: { inner: '分析・診断サービス依頼'},
  },
  components: {
    sucDialog: entSuccessed,
    appDialog: isFailured,
    valiDialog: valiErrored,
    sucDialog4Staff: entSuccessed4staff,
    LoadingDialog: Loading,
    LoadingDialog2: Loading2,
  },  

  data() {
    return {
      drawer: null,
      isShowCart: true,
      inputCols: 8,
      cartCols: 4,
      selectTab: "1",
      tabTitles: [
        {id: "1", name: '分析サンプルを追加する'},
        {id: "2", name: 'マイ機器から分析サンプル追加する'},
      ],
      stepper1: 1,
      stepper2: 1,

//      isItemsInclude: false,  
//      analizeItemListInclude: [],
      overlayStepper1: false,

      AnalizeTypeCategory: "",
      machineTypeText: "",

      analizeTypeGroupList: [],
      oilTypeCategoryList: [],

      analizeTypeList: [],
      analizeItemList: [],  // 該当分析区分の分析項目リスト
      analizeItemSubList: [],  // 該当分析区分の分析項目（サブ）リスト
      activeAnalizeItemList: [],  // 選択中のセットに含まれる項目を除いた分析リスト（依頼できる分析項目リスト）

      isSelectAnalizeSet: false,
      analizeSetItems: [], // セットに含まれる分析項目リスト
      analizeItemNames: [], // 選択中の個別分析項目の名称リスト

      OilTypeList:[],
      OilTypeCategory:"",
      OilTypeCategoryText:"",
      OilType: "",
      OilTypeText: "",

      hasOilProperties: false,
      OilPropertyList:[
        {Value:"010100", Text:"水溶性"},
        {Value:"010200", Text:"油性"},
      ],
      OilProperty:"",
      OilPropertyText:"",

      HazardousMaterialsDetail: "",
      isHazardousMaterials: false,

      Filter: "001",
      Surplus: "0",
      isAccept: "1",

      analizeSetList: [],
      AnalizeItems: [],

      AnalizeItemSub: {},
      AnalizeItemSubError: {},

      selectedSamples: [],

      AnalizeType: "",
      AnalizeTypeName: "",
      AnalizeTypeGroup: "",
      AnalizeSet: "",
      AnalizeSetName: "",

      SampleName: "",
      SampleMemo: "",
      SameCount: 1,

      LatestOrderNumber: "",

      Opinion: false,
      OpinionDescription:"分析項目を選択してみたが念のため相談したい、どのような分析項目を選べばよいかわからない、などご不明点がある場合チェックしてください。",
      isOpinionDisabled: false,
      isOpinionMemoDisabled: false,
      SampleMessage: "",
      OpinionAnswered: false,

      editid:"", //編集中サンプルのid
      viewid:"", //表示中サンプルのid
      doAddSample: false, //サンプル追加（更新）ボタンを押せるか

      machines: [],
      searchMachineKeyword: '',
      machineListPage: 1,
      machineListPageCount: 0,
      machineListItemsPerPage: 10,
      itemsPerPageList: [ 10,30,50 ],
      isShowMachineList: false,
      machineListHeadersStandard: [
        {
          text: 'マイ機器ＩＤ',
          value: 'CustomerMachineID',
          class: "teal darken-1 white--text",
          filter: this.keywordFilter,
        },
        {
          text: 'マイ機器名',
          align: 'start',
          value: 'Name',
          class: "teal darken-1 white--text",
        },
/*
        {
          text: '選択',
          value: 'id',
          class: "teal darken-1 white--text",
          width: '10%',
          sortable: false,
        },
*/
      ],
      machineListHeadersJET: [
        {
          text: 'マイ機器ＩＤ',
          value: 'CustomerMachineID',
          class: "teal darken-1 white--text",
          filter: this.keywordFilter,
        },
/*
        {
          text: 'マイ機器名',
          align: 'start',
          value: 'Name',
          class: "teal darken-1 white--text",
        },
*/
        {
          text: 'マイ機器名',
          align: 'start',
          value: 'MountedMachineID',
          class: "teal darken-1 white--text",
          filter: this.mountedMachineFilter,
        },
        {
          text: '搭載位置',
          align: 'start',
          value: 'MountPosition',
          class: "teal darken-1 white--text",
        },

      ],
      aircraftID: "",
      aircrafts: [],
      isShowAircraftList: true,
      aircraftListPage: 1,
      aircraftListPageCount: 0,
      aircraftListItemsPerPage: 10,
      aircraftListHeaders: [
/*
        {
          text: 'マイ機器ＩＤ',
          value: 'CustomerMachineID',
          class: "teal darken-1 white--text",
          width: '30%'
        },
*/
        {
          text: 'マイ機器名',
          align: 'start',
          value: 'Name',
          class: "teal darken-1 white--text",
          width: '60%'
        },
      ],
      page: 0,

      MachineID: "0000000000",
      CustomerMachineID: "",
      MachineName: "",

      OilmakerID: "",
      OilModelNumber: "",
      MakerID:"",
      ModelNumber:"",

      Price: 0,
      Fee: 0,
      SetPrice: 0,
      Require:0,
      SetRequire:0,
      FilterFee:0,
      SurplusFee:0,

      TotalPrice:0,
      TotalFee: 0,
      OpinionCount: 0,
      AnsweredCount: 0,
      SurplusCount: 0,
      Ratio: 0,
      Rounding: 0,

      //注文番号どうする？
      CustomerOrderNumber: "",

      isPageMove: false,
      processing: false,
      showSearch: true,

      ApplicationName: "",
      quote: {},
      quoteid: "",

      mountedMachine: null,

//ここより↑生き

      RepCompany: "",
      OrdererName: "",

      applicationDate: "",
      applicationDatePicker: false,
      loading: false,

      selectedOffice: "",
      selectedOfficeName: "",
      samples: [],

      officeList: [],

      invalidOilUsageTimeValue: false,
      isConfirmed: false,
      isCreate: true,

      successUrl: '/',
      successText: '分析依頼のお見積り依頼を登録しました。',
      valiErrorText: '依頼内容に不備がございます<br>赤字のエラー箇所を修正ください</p>',
      failureUrl: '/',
      loadingMessage: "処理中です。しばらくこのままでお待ちください。",
      loading2Message: "読み込み処理中...",
      progressMessages: [{"status":0, "message":"サンプルの登録"}, {"status":0, "message":"お見積りの登録"}],

/*
      samplesHeaders: [
        {
          text: '試験依頼番号',
          value: 'CustomerOrderNumber',
          class: "grey darken-2 white--text",
          width: '10%',
          sortable: false,
        },
        {
          text: '試料番号',
          value: 'SampleID',
          class: "amber darken-1 black--text",
          width: '5%'
        },
        {
          text: '定期登録番号',
          value: 'CustomerMachineID',
          class: "grey darken-2 white--text",
          width: '12%'
        },
        {
          text: '使用機器名',
          align: 'start',
          value: 'Name',
          class: "grey darken-2 white--text",
          width: '15%',
          sortable: false,
        },
        {
          text: 'オイルメーカー',
          align: 'start',
          value: 'OilmakerID',
          class: "grey darken-2 white--text",
          width: '12%',
          sortable: false,
        },
        {
          text: 'オイル名',
          align: 'start',
          value: 'OilModelNumber',
          class: "grey darken-2 white--text",
          width: '15%',
          sortable: false,
        },
        {
          text: '採取日',
          align: 'start',
          value: 'SamplingAt',
          class: "amber darken-1 black--text",
          width: '13%'
        },
        {
          text: 'オイル使用時間',
          align: 'end',
          value: 'OilUsageTime',
          class: "amber darken-1 black--text",
          width: '10%',
          sortable: false,
        },
        {
          text: '削除',
          value: 'id',
          align: 'center',
          class: "grey darken-2 white--text",
          width: '6%',
          sortable: false,
        },
        {
          text: '',
          value: 'data-table-expand',
          class: "grey darken-2 white--text",
          width: '2%',
          sortable: false,
        },
      ],
*/
      confirmSamplesHeaders: [
        {
          text: '',
          align: 'start',
          value: 'Status',
          class: "white--black",
          width: '3%',
          sortable: false,
        },
        {
          text: 'サンプル名',
          align: 'start',
          value: 'Name',
          class: "white--black",
          width: '20%',
          sortable: false,
        },
        {
          text: 'オイル',
          align: 'start',
          value: 'OilTypeText',
          class: "white--black",
          width: '22%',
          sortable: false,
        },
        {
          text: '分析セット',
          align: 'start',
          value: 'AnalizeSetName',
          class: "white--black",
          width: '22%',
          sortable: false,
        },
        {
          text: '個数',
          align: 'end',
          value: 'SameCount',
          class: "white--black",
          width: '5%',
          sortable: false,
        },        {
          text: 'オプション',
          align: 'start',
          value: 'Options',
          class: "white--black",
          width: '8%',
          sortable: false,
        },
        {
          text: '分析料金',
          align: 'end',
          value: 'Fee',
          class: "white--black",
          width: '10%',
          sortable: false,
        },
        {
          text: 'マイ機器ID',
          value: 'CustomerMachineID',
          class: "white--black",
          width: '10%',
          sortable: false,
        },
      ],

      editedIndex: -1,
    };
  },
  validations() {
    let _validations = {
//    CustomerOrderNumber: { required, eneosOrderNumber, maxLength: maxLength(8) },
      selectedOffice: { required, },
//    applicationDate: { required, },
      selectedSamples: { required, },
//    RepCompany: { required, },
      AnalizeTypeGroup: { required },
      AnalizeType: { required },
      AnalizeSet: { isAnalizeSet },
      AnalizeItems: { isAnalizeSet, analizeItemRelations, analizeItemRelationPCSA1, analizeItemRelationPCSA2, analizeItemRelationVI___J, analizeItemRelationGCVC_J, analizeItemRelationNCVC_J, analizeItemRelationCETINJ, analizeItemRelationPHO__X, analizeItemRelationPHO2_X,analizeItemRelationSOAP6X,analizeItemRelationSOAP5X,analizeItemRelationRA___Z },
      AnalizeItemSub: {analizeItemRelations},
      HazardousMaterialsDetail: { hasHazardousMaterialsDetail },
      OilTypeCategory: { required },
      OilType: { required },
      OilTypeText: { required, maxLength: maxLength(20) },
      OilProperty: { requiredOilProperty },

      SampleMemo: { maxLength: maxLength(64), hasOpinionRequestDetail },
      SampleMessage: { maxLength: maxLength(64), hasOpinionAnswer },
      ApplicationName: { maxLength: maxLength(50) },
      SameCount: { required, },
    }

    if (this.AnalizeTypeCategory == '一般') {
      _validations["SampleName"] = { required, maxLength: maxLength(20) }
    }else {
      _validations["SampleName"] = { required, alphaNumPlus, maxLength: maxLength(15) }
    }
    return _validations

},
  filters: {
    addComma: function (value) {
      return value.toLocaleString();
    }
  },
  computed: {
    machineListHeaders() {
      if (this.AnalizeTypeCategory == '一般') {
        return this.machineListHeadersStandard
      }else {
        return this.machineListHeadersJET
      }
    },
    getSelectAircraftBtnStyle() {
//      if(this.aircraftID) {
      if(this.isShowAircraftList) {
        return true
      }else if(this.aircraftID) {
        return true
      }else {
        return false
      }
    },
//    CustomerOrderNumberErrors () { return this.defaultMessage(this.$v.CustomerOrderNumber) },
    selectedOfficeErrors () { return this.defaultMessage(this.$v.selectedOffice) },
//    applicationDateErrors () { return this.defaultMessage(this.$v.applicationDate) },
//    RepCompanyErrors () { return this.defaultMessage(this.$v.RepCompany) },

    AnalizeTypeGroupErrors () {
      return this.defaultMessage(this.$v.AnalizeTypeGroup)
    },
    AnalizeSetErrors () {
      return this.defaultMessage(this.$v.AnalizeSet)
    },
    AnalizeItemsErrors () {
      return this.defaultMessage(this.$v.AnalizeItems)
    },
    OilTypeCategoryErrors () {
      return this.defaultMessage(this.$v.OilTypeCategory)
    },
    OilTypeErrors () {
      return this.defaultMessage(this.$v.OilType)
    },
    OilTypeTextErrors () {
      return this.defaultMessage(this.$v.OilTypeText)
    },    
    OilPropertyErrors () {
      return this.defaultMessage(this.$v.OilProperty)
    },    
    HazardousMaterialsDetailErrors () {
      return this.defaultMessage(this.$v.HazardousMaterialsDetail)
    },
    SampleNameErrors () {
      return this.defaultMessage(this.$v.SampleName)
    },
    SampleMemoErrors () {
      return this.defaultMessage(this.$v.SampleMemo)
    },
    SampleMessageErrors () {
      return this.defaultMessage(this.$v.SampleMessage)
    },
    SameCountErrors () {
      return this.defaultMessage(this.$v.SameCount)
    },
    ApplicationNameErrors () {
      return this.defaultMessage(this.$v.ApplicationName)
    },

    useUnits () {
      return this.$store.state.useUnits
    },

    getNoticeType () {
      return this.getNoticeTypeCore(this.isHazardousMaterials, this.isAccept)
    },
    modeText() {
      if(this.isCreate == false) {
        if(this.$store.state.isStaff == true) {
          return "の更新（お見積りのご相談）"
        }else {
          return "の更新"
        }
      }else{
        return ""
      }
    },
    addSampleButtonText() {
      if(this.editid == "") {
        return "サンプルを追加"
      }else{
        return "サンプルを更新"
      }
    },
    quoteReturnAlert() {
      //スタッフによる更新で、相談するがなくなっている場合
      if((this.$store.state.isStaff == true) && (this.OpinionCount == this.AnsweredCount)){
        return 1
      //スタッフによる更新で、相談するが残っている場合
      }else if((this.$store.state.isStaff == true) && (this.OpinionCount != this.AnsweredCount)){
        return 2
      }else {
        return 0
      }
    },
    returnPath() {
      if(this.isCreate == true) {
        return { path: '/' }
      }else if(this.$store.state.isStaff == true){
        return { path: '/staffpage' }
      }else {
        return { path: '/quotesheet', query: {id: this.quoteid}}
      }
    }
  },
  mounted: async function () {
    this.Ratio = Number(this.$store.state.operatingCompany.Ratio) / 100
    this.Rounding = this.$store.state.operatingCompany.Rounding

    this.initialize()
  },
  methods: {
    getSelectAircraftBtnLabel() {
      if(this.aircraftID) {
        return "機体を選びなおす"
      }else {
        return "機体で絞り込む"
      }
    },
    keywordFilter(value) {
      return value.toLowerCase().includes(this.searchMachineKeyword.toLowerCase())
    },
    mountedMachineFilter(value){
      if(this.aircraftID == null) {
        return true
      }else if(value == null) {
        return false
      }else {
        return value.toLowerCase().includes(this.aircraftID.toLowerCase());
      }
    },
    showAircraftList: async function() {
      this.aircraftID = null
      this.isShowAircraftList = true
      this.isShowMachineList = false
    },
    closeAircraftList: async function() {
      this.aircraftID = null
      this.isShowAircraftList = false
      this.isShowMachineList = true
    },
    selectAircraft(aircraft) {
      console.log("selectAircraft:", aircraft.CustomerMachineID)
      this.aircraftID = aircraft.id
      this.isShowMachineList = true
      this.isShowAircraftList = false
    },
    numSampleID (sampleid) {
      return ( '000' + Number(sampleid) ).slice( -3 );
    },
    getNoticeTypeCore (isHazardousMaterials, isAccept) {
      if (isHazardousMaterials == "1"){
        if(isAccept == "1") {
          // 危険物を含む 且つ 分析・診断サービス利用可
          return 1
        }else {
          // 危険物を含む 且つ 分析・診断サービス利用不可
          return 2
        }
      }else {
        if(isAccept == "1") {
          // 危険物を含まない 且つ 分析・診断サービス利用可
          return 3
        }else {
          // 危険物を含まない 且つ 分析・診断サービス利用不可
          return 4
        }
      }
    },
    isOpinionRequired: function(isHazardousMaterials, isAccept) {
      // case 1（危険物含むが利用できる）
      if ((isHazardousMaterials == "1") && (isAccept == "1")){
        return true
      // case 2（危険物含むので利用できない）
      }else if ((isHazardousMaterials == "1") && (isAccept == "0")){
        return true
      // case 3（通常）
      }else if ((isHazardousMaterials == "0") && (isAccept == "1")){
        return false
      // case 4（危険物含まないが利用できない）
      }else {
        return true
      }

    },
    getAddSampleButtonDisabled: function() {
      if(this.processing) {
        return true
      }
      if(this.isCreate) {
        return false
      }else {
        if(this.viewid) {
          return true
        }else{
          return false
        }
      }

    },
    getSampleButtonDisabled: function(sample) {
      let status = {}
      if(this.isCreate) {
        // 作成モードなら、参照以外可
        status = {edit: false, copy: false, delete: false, check: true}
      }else {
        if(sample.insert) {
          // 更新モードで追加したサンプルは、参照以外可
          status = {edit: false, copy: false, delete: false, check: true}
        }else {
          // 更新モード
          // スタッフの場合
          if(this.$store.state.isStaff) {
            // 相談中のサンプル
            if( sample.Status == "quoteRequest") {
              status = {edit: false, copy: true, delete: true, check: false}
            // 回答済みのサンプル
            }else if( sample.Status == "quoteReturn") {
              status = {edit: false, copy: true, delete: true, check: false}
            // その他
            }else {
              status = {edit: true, copy: true, delete: true, check: false}
            }
          // クライアントの場合
          }else {
            // 相談中、正式依頼済み、キャンセル済みのサンプル
            if(( sample.Status == "quoteRequest") ||
               ( sample.Status == "quoteApplied") ||
               ( sample.Status == "quoteCanceled")
               ){
              status = {edit: true, copy: true, delete: true, check: false}
            // その他（発行済み、回答済み）
            }else {
              status = {edit: false, copy: false, delete: false, check: true}
            }
          }
        }
/*
        }else if(this.$store.state.isStaff) {
          if(sample.Status == "quoteRequest") {
            status = {edit: false, copy: true, delete: true, check: false}
          }else {
            status = {edit: true, copy: true, delete: true, check: false}
          }
        }else {
          status = {edit: false, copy: false, delete: false, check: true}
        }
*/
      }
      return status
    },
    getCreateQuoteButtonDisabled: function() {
      if(this.selectedSamples.length >= 1) {
        return false
      }else {
        return true
      }
    },
    changeTab: async function(tab) {
      this.selectTab = tab
      if(tab == 2) {
        this.searchMachine(this.$store.state.operatingOffice.OfficeID)
      }
      this.reset()
    },
    reset: async function() {
//console.log("reset start")
      // 入力をリセット
      await this.$refs.sampling_form.reset();
      this.Opinion = false
      this.OpinionAnswered = false
      // radio-groupは値が変わらないと画面描画のイベントが起きないようなので、2回セット
      this.Filter= "001"
      this.changeFilter(this.Filter)

      this.Surplus = "0"

      this.isAccept = "1"
      this.SameCount = "1"

      this.SetPrice = 0
      this.SetRequire = 0
      this.Price = 0
      this.Fee = 0
      this.Require = 0

      this.OilTypeCategoryText = ""
      this.OilTypeText = ""
      this.MachineID = "0000000000"
      this.mountedMachine = null
      this.CustomerMachineID = ""
      this.MachineName = ""
      this.ModelNumber = ""
      
      this.MakerID = ""
      this.OilModelNumber = ""
      this.OilmakerID = ""

      this.HazardousMaterialsDetail = ""
      this.isHazardousMaterials = false

      this.LatestOrderNumber = ""

      this.editid = ""
      this.viewid = ""

//console.log("$v.$reset()")

      // バリデーションエラーをリセット
			this.$nextTick(() => { this.$v.$reset() })

      // step1を表示
      this.stepper1 = 1
      this.stepper2 = 1
//console.log("reset end")
    },
    initialize: async function () {
      if (this.$route.query.id == undefined){
        this.isCreate = true
        this.AnalizeTypeCategory = this.$route.query.category
        this.analizeTypeGroupList = await this.getAnalizeTypeGroupList(this.AnalizeTypeCategory)
        this.oilTypeCategoryList = await this.getOilTypeCategoryList(this.AnalizeTypeCategory)
      }else {
        this.isCreate = false
        this.OpinionCount = 0
        this.AnsweredCount = 0
        this.SurplusCount = 0
        this.quoteid = this.$route.query.id
        let application = await API.graphql(graphqlOperation(getApplication, {id: this.quoteid}))
        this.quote = application.data.getApplication
        this.ApplicationName = this.quote.Name
        this.TotalPrice = Number(this.quote.Price)
        this.TotalFee = Number(this.quote.Fee)
        this.OrdererName = this.quote.OrdererCompanyName + " " + this.quote.OrdererOfficeName + " " + this.quote.OrdererName

        this.AnalizeTypeCategory = this.getApplicationAnalizeTypeCategory(this.quote)
        console.log("quote AnalizeTypeCategory:", this.AnalizeTypeCategory)
        this.analizeTypeGroupList = await this.getAnalizeTypeGroupList(this.AnalizeTypeCategory)
        console.log("quote analizeTypeGroupList:", this.analizeTypeGroupList)
        this.oilTypeCategoryList = await this.getOilTypeCategoryList(this.AnalizeTypeCategory)

        // samplesByApplicationを使用してサンプルを取得
        let samples = await API.graphql(graphqlOperation(samplesByApplication, {ApplicationID: this.quoteid, limit: 999}))
        let _samples = samples.data.samplesByApplication.items;
        _samples.sort(function(a,b){
            if(a.createdAt < b.createdAt) return -1;
            if(a.createdAt > b.createdAt) return 1;
            return 0;
        });
        this.selectedSamples = _samples

        for (const sample of this.selectedSamples) {
          this.AnalizeTypeGroup = sample.AnalizeTypeGroup
          await this.changeAnalizeTypeGroup()

          this.AnalizeType = sample.AnalizeType
          await this.changeAnalizeType()

          this.AnalizeSet = sample.AnalizeSet
          await this.changeAnalizeSet()

          this.AnalizeItems = JSON.parse(sample.AnalizeItems)
          sample["AnalizeItems"] = this.AnalizeItems
          await this.changeAnalizeItems(this.AnalizeItems)
          sample["AnalizeItemNames"] = JSON.parse(sample.AnalizeItemNames)

          this.AnalizeItemSub = {}
          let _AnalizeItemSub = "{}"
          if(sample.AnalizeItemSub != undefined) {
            _AnalizeItemSub = JSON.parse(sample.AnalizeItemSub)
            sample["AnalizeItemSub"] = _AnalizeItemSub
//            this.AnalizeItemSub = _AnalizeItemSub
          }

//          sample["analizeItemListInclude"] = this.analizeItemListInclude
//          sample["AnalizeItemsInclude"] = this.AnalizeItemsInclude
          sample["analizeSetItems"] = this.analizeSetItems
          sample["analizeItemList"] = this.activeAnalizeItemList


          // 全分析項目の項目名のリスト（追加項目を含む）
          // 原因不明。2回parseしないと処理できない。なぜだ。
//          let allAnalizeItemNames = await this.getAnalizeItemNames(this.AnalizeItems, this.AnalizeItemSub, this.analizeItemList, this.analizeItemSubList)
          let allAnalizeItemNames = await this.getAnalizeItemNames(this.AnalizeItems, JSON.parse(_AnalizeItemSub), this.analizeItemList, this.analizeItemSubList)
          console.log("allAnalizeItemNames:", allAnalizeItemNames)
          sample["allAnalizeItemNames"] = allAnalizeItemNames


          sample["insert"] = false
          sample["delete"] = false
          sample["update"] = false
          sample["Opinion"] = this.toBoolean(sample.Opinion)

          sample["Price"] = Number(sample.Price)
          sample["Fee"] = Number(sample.Fee)

          // 相談サンプル件数
          if(sample["Opinion"]) {
            this.OpinionCount ++
          }

          // サンプル返却希望件数
          if(sample["Surplus"] == "1"){
            this.SurplusCount ++
          }

          // 相談回答済み件数
          if(sample["Status"] == "quoteReturn"){
            this.AnsweredCount ++
          }
/*
          let analizeItemNameList = []
          for (var AnalizeItem of this.AnalizeItems) {
            let item = this.analizeItemList.filter(item => item.Value  == AnalizeItem)
            analizeItemNameList.push(item[0])
          }
          sample["analizeItemNameList"] = analizeItemNameList
*/
        }
        await this.reset()
      }

      if(this.AnalizeTypeCategory == "一般") {
        this.isShowMachineList = true
        this.machineTypeText = "マイ機器"
        this.aircraftID = null
      }else {
        this.isShowMachineList = false
        this.machineTypeText = "装備品"
      }

      this.overlayStepper1 = false
    },
/*
    showCart: async function () {
      if (this.isShowCart) {
        this.isShowCart = false
        this.inputCols=10
        this.cartCols=2
      } else {
        this.isShowCart = true
        this.inputCols=8
        this.cartCols=4
      }
    },
    openAgreement() {
        window.open(this.agreement_url, '_blank')
    },
*/

/*
    changeOffice: async function () {
        const Office = this.officeList.filter(item => item.OfficeID  == this.selectedOffice)
        this.selectedOfficeName = Office[0].Name
        this.searchMachine()
    },
*/
    getAirCraftName: function(machine) {
      if(machine.MountedMachineID) {
        const aircraft = this.aircrafts.filter(item => item.id  == machine.MountedMachineID)
        let name = ""
        if(aircraft[0]) {
          name = aircraft[0].Name
        }else {
          name = "不明な機体"
        }
        return name
      }else{
        return machine.Name+"*"
      }
    },
    selectMachine: async function(machine) {
      console.log("selectMachine", machine)
      this.$refs.isLoading2.start();
//      this.reset()
      this.AnalizeTypeGroup = machine.AnalizeTypeGroup
      await this.changeAnalizeTypeGroup()

      this.OilTypeCategory = machine.OilTypeCategory
      await this.changeOilTypeCategory()

      this.OilType = machine.OilType
      await this.changeOilType()
            
      this.AnalizeType = machine.AnalizeType
      await this.changeAnalizeType()

      this.AnalizeSet = machine.AnalizeSet
      await this.changeAnalizeSet()

      this.AnalizeItems = JSON.parse(machine.AnalizeItems)
      if(machine.AnalizeItemSub != undefined) {
        this.AnalizeItemSub = JSON.parse(machine.AnalizeItemSub)
      }else {
        this.AnalizeItemSub = {}
      }
      await this.changeAnalizeItems(this.AnalizeItems)

      if(this.AnalizeTypeCategory == "航空機") {
        this.SampleName = machine.CustomerMachineID
      }else {
        this.SampleName = machine.Name
      }

      // この機器が機体と関連づいている場合は機体情報を取得
      if((machine.MountedMachineID != undefined) && (machine.MountedMachineID != "")) {
        let mountedMachine = await API.graphql(graphqlOperation(getMachine, {id: machine.MountedMachineID}))
        this.mountedMachine = mountedMachine.data.getMachine
      }else {
        this.mountedMachine = null
      }

      this.SameCount = 1
      this.Filter = machine.Filter
      this.changeFilter(machine.Filter)
      
      this.Surplus = machine.Surplus

      this.MachineID = machine.id
      this.CustomerMachineID = machine.CustomerMachineID
      this.MachineName = machine.Name
      if(this.mountedMachine) {
        this.MachineName = this.mountedMachine.Name
      }
      this.ModelNumber = machine.ModelNumber
      
      this.MakerID = machine.MakerID
      this.OilModelNumber = machine.OilModelNumber
      this.OilmakerID = machine.OilmakerID

      this.OilProperty = machine.OilProperty
      this.OilPropertyText = machine.OilPropertyText

      this.SampleMemo = machine.HazardousMaterialsDetail

      this.LatestOrderNumber = machine.LatestOrderNumber

      this.stepper2 = 2
      this.$refs.isLoading2.end();
    },
    addSample: async function() {
      this.processing = true
      if(this.selectTab == 1) {
        let valid = this.validation(4)
        //バリデーションエラーの場合引数-1が返ってくる
        if(valid == 3) {
          return
        }
      }else {
        let valid = this.validation2(4)
        //バリデーションエラーの場合引数-1が返ってくる
        if(valid == 3) {
          return
        }
      }

//      this.$v.CustomerOrderNumber.$touch()
//      if (this.$v.CustomerOrderNumber.$invalid) {
//        return
//      }

//      console.log("machine memo", sample.MachineMemo)
//      const memos = sample.MachineMemo.split('\n');
//      for (var memo of memos) {
//        if(memo.indexOf("得意先名：") != -1) {
//          console.log("得意先名", memo.substr(5))
//          this.RepCompany = memo.substr(5)
//        }else if(memo.indexOf("需要家名：") != -1)
//        console.log("需要家名",  memo.substr(5))
//      }

      //※引数sampleは実際はmachineのレコード
      //Application.idの値を自己生成 形式は4×4
      let uuid = this.generateUuid("xxxx-xxxx-4xxx-yxxx")
      let _sample = {}
      let editIndex = -1

      let beforeOpinion
      let beforeSurplus
      let beforeStatus
      // 更新中の場合、更新中のレコードを更新
      if(this.editid != "") {
        let _samples = this.selectedSamples.filter(item => item.id  == this.editid)
        _sample = _samples[0]
        beforeOpinion = _sample.Opinion
        beforeSurplus = _sample.Surplus
        beforeStatus = _sample.Status
        editIndex = this.selectedSamples.findIndex(item => item.id  == this.editid)
      // 追加の場合は新しいレコードを追加
      }else {
        _sample["id"] = uuid
        // とりあえず暫定のサンプルIDを設定（末尾）
        // ※DB更新時に再度採番し直し
        _sample["SampleID"] = this.selectedSamples.length + 1
        beforeOpinion = null
        beforeSurplus = null
        beforeStatus = null
      }

      _sample["CustomerOrderNumber"] = this.CustomerOrderNumber
      _sample["CustomerMachineID"] = this.CustomerMachineID
      _sample["MachineID"] = this.MachineID
      _sample["Name"] = this.SampleName
      _sample["OilmakerID"] = this.OilmakerID
      _sample["OilModelNumber"] = this.OilModelNumber
      _sample["OilTypeCategory"] = this.OilTypeCategory
      _sample["OilTypeCategoryText"] = this.OilTypeCategoryText
      _sample["OilType"] = this.OilType
      _sample["OilTypeText"] = this.OilTypeText
      _sample["OilProperty"] = this.OilProperty
      _sample["OilPropertyText"] = this.OilPropertyText

      _sample["SamplingAt"] = ""
      // とりあえず固定
      _sample["OperatingTime"] = null
      _sample["OperatingTimeUnit"] = ""
      _sample["OperatingTimeUnitText"] = ""
      // とりあえず固定
      _sample["OilUsageTime"] = null
      _sample["OilUsageTimeUnit"] = ""
      _sample["OilUsageTimeUnitText"] = ""
      _sample["isHazardousMaterials"] = this.isHazardousMaterials
      _sample["HazardousMaterialsDetail"] = this.HazardousMaterialsDetail
      _sample["MakerID"] = this.MakerID
      _sample["ModelNumber"] = this.ModelNumber
      _sample["AnalizeTypeGroup"] = this.AnalizeTypeGroup
      _sample["AnalizeTypeGroupName"] = this.AnalizeTypeGroupName
      _sample["AnalizeType"] = this.AnalizeType
      _sample["AnalizeItems"] = this.AnalizeItems
      _sample["AnalizeItemSub"] = JSON.stringify(this.AnalizeItemSub)
      console.log("addSample AnalizeItemSub", _sample["AnalizeItemSub"])
      _sample["AnalizeSet"] = this.AnalizeSet

      _sample["AnalizeTypeName"] = this.AnalizeTypeName
      _sample["AnalizeSetName"] = this.AnalizeSetName

      _sample["SameCount"] = this.SameCount
      _sample["Filter"] = this.Filter
      _sample["Surplus"] = this.Surplus

      _sample["LatestOrderNumber"] = this.LatestOrderNumber

      _sample["Opinion"] = this.Opinion

      _sample["Memo"] = this.SampleMemo
      _sample["Message"] = this.SampleMessage

      _sample["Price"] = this.Price
      _sample["Fee"] = this.Fee + this.FilterFee
      _sample["SetPrice"] = this.SetPrice
      _sample["Require"] = this.Require
      _sample["SetRequire"] = this.SetRequire

      // サンプルのレコードでは持たない。表示用
      _sample["MachineName"] = this.MachineName
      _sample["mountedMachine"] = this.mountedMachine

      let analizeItemNames = []
      for (var AnalizeItem of this.AnalizeItems) {
        let item = this.analizeItemList.filter(item => item.Value  == AnalizeItem)
        analizeItemNames.push(item[0])
      }
      _sample["AnalizeItemNames"] = analizeItemNames

      //セットに含まれる分析項目リスト（表示用）
//      _sample["analizeItemListInclude"] = this.analizeItemListInclude
//      _sample["AnalizeItemsInclude"] = this.AnalizeItemsInclude
//      _sample["analizeItemList"] = this.analizeItemList
      _sample["analizeSetItems"] = this.analizeSetItems
      _sample["analizeItemList"] = this.activeAnalizeItemList

      // 全分析項目の項目名のリスト（追加項目を含む）
      let allAnalizeItemNames = await this.getAnalizeItemNames(this.AnalizeItems, this.AnalizeItemSub, this.analizeItemList, this.analizeItemSubList)
      console.log("allAnalizeItemNames:", allAnalizeItemNames)
      _sample["allAnalizeItemNames"] = allAnalizeItemNames

      // サンプル毎のステータス
      // 相談していない quoteIssued  発行済み
      // 相談している   quoteRequest 見積書 依頼中
      let status = ""
      if(this.Opinion == true) {
        status = "quoteRequest"
      }else {
        status = "quoteIssued"
      }
      // さらに、スタッフによる見積確認済み 確認済み quoteApplied
//      console.log("OpinionAnswered", this.OpinionAnswered)
      if(this.OpinionAnswered == true) {
        status ="quoteReturn"
      }

      _sample["Status"] = status

      if(this.editid == "") {
        if(!this.isCreate) {
          _sample["insert"] = true
        }
        this.selectedSamples.push(_sample)
      }else {
        console.log("updateSample", editIndex)
        if(!this.isCreate) {
          if(!_sample.insert) {
            _sample["update"] = true
            _sample["delete"] = false
          }
        }

        this.selectedSamples[editIndex] = _sample
        this.editid = ""
        this.viewid = ""
      }

      // 相談サンプル数の計算
      if(beforeOpinion == null) {
        if(this.Opinion) {
          this.OpinionCount++
        }
      }else {
        if(beforeOpinion) {
          if(!this.Opinion) {
            this.OpinionCount--
          }
        }else{
          if(this.Opinion) {
            this.OpinionCount++
          }
        }
      }

      // サンプル返却希望数の計算
      if(beforeSurplus == null) {
        if(this.Surplus == "1") {
          this.SurplusCount++
        }
      }else {
        if(beforeSurplus == "1") {
          if(this.Surplus == "0") {
            this.SurplusCount--
          }
        }else{
          if(this.Surplus == "1") {
            this.SurplusCount++
          }
        }
      }

      // 相談回答件数の計算
      if((beforeStatus == "quoteRequest") && (status == "quoteReturn")){
        this.AnsweredCount++
      }else if((beforeStatus == "quoteReturn") && (status == "quoteRequest")){
        this.AnsweredCount--
      }

      // 総額集計処理
      this.calcAmount()

      // 登録前の画面遷移を警告
      this.isPageMove=true
      await this.reset()
      this.processing = false
    },
    viewSample: async function(sample) {
      if(sample.MachineID == "0000000000"){
        this.selectTab = "1"
      }else {
        this.selectTab = "2"
        this.stepper2 = 2
      }
      await this.copySample(sample)
      this.editid = ""
      this.viewid = sample.id
      this.doAddSample = false
    },
    editSample: async function(sample) {
      if(sample.MachineID == "0000000000"){
        this.selectTab = "1"
      }else {
        this.selectTab = "2"
        this.stepper2 = 2
      }
      await this.copySample(sample)
      this.viewid = ""
      this.editid = sample.id

      if(this.$store.state.isStaff) {
        this.isOpinionDisabled = true
        this.isOpinionMemoDisabled = true
        if(sample.Status == "quoteReturn") {
          this.OpinionAnswered = true
        }else {
          this.OpinionAnswered = false
        }
        this.stepper1 = 2
      }
      this.doAddSample = true
    },
    copySample: async function(sample) {
      this.$refs.isLoading2.start();
      this.viewid = ""
      this.editid = ""

      // 一旦入力をリセットして準備
      this.AnalizeTypeGroup = ""
      this.OilTypeCategory = ""
      this.OilType = ""
      this.AnalizeType = ""
      this.AnalizeSet = ""
      this.AnalizeItems = ""

      this.AnalizeTypeGroup = sample.AnalizeTypeGroup
      await this.changeAnalizeTypeGroup()

      this.OilTypeCategory = sample.OilTypeCategory
      await this.changeOilTypeCategory()
      this.OilType = sample.OilType
      await this.changeOilType()

      this.OilProperty = sample.OilProperty
      this.OilPropertyText = sample.OilPropertyText

      this.AnalizeType = sample.AnalizeType
      await this.changeAnalizeType()

      this.AnalizeSet = sample.AnalizeSet
      await this.changeAnalizeSet()

      this.AnalizeItems = sample.AnalizeItems
      if(sample.AnalizeItemSub != undefined) {
        this.AnalizeItemSub = JSON.parse(sample.AnalizeItemSub)
      }else {
        this.AnalizeItemSub = {}
      }
      console.log("copySample AnalizeItemSub", sample.AnalizeItemSub)
      await this.changeAnalizeItems(this.AnalizeItems)


      this.SampleName = sample.Name
      this.SameCount = sample.SameCount
      this.Filter= sample.Filter
      await this.changeFilter(sample.Filter)

      this.Surplus= sample.Surplus

      this.LatestOrderNumber = sample.LatestOrderNumber

      this.MachineID = sample.MachineID
      this.MachineName = sample.MachineName
      this.CustomerMachineID = sample.CustomerMachineID
      this.ModelNumber = sample.ModelNumber

      this.MakerID = sample.MakerID
      this.OilModelNumber = sample.OilModelNumber
      this.OilmakerID = sample.OilmakerID

      this.Opinion = sample.Opinion
      this.SampleMemo = sample.Memo
      this.SampleMessage = sample.Message

      this.mountedMachine = sample.mountedMachine

      this.isAccept= "1"

      // サンプルを追加（更新)ボタンを押せる
      this.doAddSample = true

      // バリデーションエラーをリセット
//			this.$nextTick(() => { this.$v.$reset() })
      // step1を表示
      this.stepper1 = 1
      this.$refs.isLoading2.end();
    },
    delSample(sample) {
      //編集中のサンプルが削除された場合は入力をクリア
      if(this.editid == sample.id) {
        this.reset()
        this.editid = ""
      }
      //表示中のサンプルが削除された場合は入力をクリア
      if(this.viewid == sample.id) {
        this.reset()
        this.viewid = ""
      }

      // 相談するサンプルが削除された場合はカウントダウン
      if(sample.Opinion) {
        this.OpinionCount--
      }
      // 相談するサンプルがサンプル返却希望された場合はカウントダウン
      if(sample.Surplus == "1") {
        this.SurplusCount--
      }

      // 見積依頼の新規追加時はサンプルを直接削除
      if(this.isCreate) {
        const newArray = this.selectedSamples.filter((item) => { return (item.id != sample.id)})
        this.selectedSamples = newArray

        // 追加中のサンプルがゼロ件になったら
        // 画面遷移を許可（警告しない）
        if(this.selectedSamples.length == 0) {
          this.isPageMove=false
        }else {
          this.isPageMove=true
        }
      // 更新時は削除フラグを立てる。
      }else {
        let _samples = this.selectedSamples.filter(item => item.id  == sample.id)
        let _sample = _samples[0]
        if(_sample.insert) {
          const newArray = this.selectedSamples.filter((item) => { return (item.id != sample.id)})
          this.selectedSamples = newArray
        }else {
          let delIndex = this.selectedSamples.findIndex(item => item.id  == sample.id)
          _sample["update"] = false
          _sample["delete"] = true
          this.selectedSamples[delIndex] = _sample
          console.log("delIndex", delIndex)

          // 登録済みのサンプルを削除した場合
          // 画面遷移時に警告
          this.isPageMove=true
        }
      }
      // 集計処理
      this.calcAmount()
      console.log("delete sample", this.selectedSamples)
    },
    calcAmount: async function () {
      let totalPrice = 0
      let totalFee = 0
      for (const item of this.selectedSamples) {
        if(item.delete != true) {
          totalPrice = totalPrice + (Number(item.Price) * Number(item.SameCount))
          totalFee = totalFee + (Number(item.Fee) * Number(item.SameCount))
        }
      }
      if(this.SurplusCount > 0) {
        let surplusFee = this.getSurplusFee("1")
        totalPrice = totalPrice + surplusFee
        totalFee = totalFee + surplusFee
//        console.log("surplusFee", surplusFee)
      }
      this.TotalPrice = totalPrice
      this.TotalFee = totalFee
    },
    validationQuote: async function () {
      this.isConfirmed = true
      this.processing = false
    },

    changeStepper: function(step) {
      this.stepper1 = this.validation(step)
    },
    changeStepper2: function(step) {
      this.stepper2 = this.validation2(step)
    },
    validation2: function (step) {
      if(step >= 2) {
        if(this.MachineID == "0000000000"){
          this.$refs.isErrored.open();
          this.isErrored = true
          this.processing = false
          return 1
        }
      }
      if(step >= 3) {
        return this.validation(step)
      }
      return step
    },

    validation: function (step) {
      console.log("validation", step)
//      this.invalidOilUsageTimeValue = false
      if(step >= 2) {
        this.$v.OilTypeCategory.$touch()
        this.$v.OilType.$touch()
        this.$v.OilProperty.$touch()
        if (this.$v.OilTypeCategory.$invalid ||
            this.$v.OilType.$invalid ||
            this.$v.OilProperty.$invalid
        ) {
          this.$refs.isErrored.open();
          this.isErrored = true
          this.processing = false
          return 1
        }
      }
      if(step >= 3) {
        // 分析内容を相談する場合はスキップ
        if(!this.Opinion) {
          this.$v.AnalizeTypeGroup.$touch()
          this.$v.AnalizeType.$touch()
          this.$v.AnalizeSet.$touch()
          this.$v.AnalizeItems.$touch()
          if (this.$v.AnalizeTypeGroup.$invalid ||
              this.$v.AnalizeType.$invalid ||
              this.$v.AnalizeItems.$invalid ||
              this.$v.AnalizeSet.$invalid
          ) {
            console.log("err", 1)
            this.$refs.isErrored.open();
            this.isErrored = true
            this.processing = false
            return 2
          }
        }else {
          this.$v.SampleMemo.$touch()
          if (this.$v.SampleMemo.$invalid
          ) {
            console.log("err", 2)
            this.$refs.isErrored.open();
            this.isErrored = true
            this.processing = false
            return 2
          }
        }

        if(this.OpinionAnswered) {
          this.$v.AnalizeSet.$touch()
          this.$v.SampleMessage.$touch()
          if (this.$v.AnalizeTypeGroup.$invalid ||
              this.$v.AnalizeType.$invalid ||
              this.$v.AnalizeSet.$invalid ||
              this.$v.SampleMessage.$invalid
          ) {
            console.log("err", 3)
            this.$refs.isErrored.open();
            this.isErrored = true
            this.processing = false
            return 2
          }
        }
      }
      if(step >= 4) {
        this.$v.SampleName.$touch()
        this.$v.SameCount.$touch()
        if (this.$v.SampleName.$invalid ||
            this.$v.SameCount.$invalid
        ) {
          this.$refs.isErrored.open();
          this.isErrored = true
          this.processing = false
          return 3
        }
      }

//      this.isConfirmed = true
      this.processing = false
      return step
    },
    createQuote: async function () {
      console.log("create Quote")
      this.isConfirmed = false
      this.processing = true

      this.$v.ApplicationName.$touch()
      if (this.$v.ApplicationName.$invalid) {
        this.$refs.isErrored.open();
        this.isErrored = true
        this.processing = false
        return
      }
      this.$refs.isLoading.start();

/*
      const Office = this.officeList.filter(item => item.OfficeID  == this.selectedOffice)
      this.selectedOfficeName = Office[0].Name

      //報告書送付先
      //試験依頼番号が99MA9999の場合 00024
      //それ以外の場合 選択した事業所
      let DelvOfficeID = this.selectedOffice
      if(this.CustomerOrderNumber.substr( 2, 2 ) == "MA") {
        DelvOfficeID = this.targetCompanyID + "00024"
      }
      //請求先 00006固定
      let PayOfficeID = this.targetCompanyID + "00006"

      let DelvOffice = this.officeList.filter(item => item.OfficeID  == DelvOfficeID)
      let PayOffice = this.officeList.filter(item => item.OfficeID  == PayOfficeID)
*/
      //Application.idの値を自己生成 形式は4×4
      let uuid = this.generateUuid("xxxx-xxxx-4xxx-yxxx")
      if(!this.isCreate){
        uuid = this.quote.id
      }

      let Status = "quoteIssued"
      let IssuedAt = null
      let ValidityAt = null
      if(!this.$store.state.isStaff) {
        if(this.OpinionCount > 0) {
          Status = "quoteRequest" // 見積依頼
        }else {
          Status = "quoteIssued" // 見積発行済み
          IssuedAt = this.getNow()
          ValidityAt = this.getQuoteValidityAt()
        }
      }else {
        if(this.OpinionCount == this.AnsweredCount) {
          Status = "quoteReturn" // 見積依頼回答済み
          IssuedAt = this.getNow()
          ValidityAt = this.getQuoteValidityAt()
        }else {
          Status = "quoteRequest" // 見積依頼
        }
      }

      let hasSurplus = false
      if(this.SurplusCount > 0) {
        hasSurplus = true
      }

//      console.log("Application Status", Status)

      const application = {
        id: uuid,
        OfficeID: this.$store.state.operatingOffice.OfficeID,
        Name: this.ApplicationName,
        AnalizeTypeCategory: this.AnalizeTypeCategory,
        Type: "Quote",

/*
        RepCompanyID: Office[0].CompanyID,
        RepOfficeID: Office[0].OfficeID.substr(10, 5),
        RepCompany: this.RepCompany,
        RepOffice: "",
        RepDept: "",
        RepPIC: "",
        RepEmployeeID: "",

        DelvCompanyID: DelvOffice[0].CompanyID,
        DelvOfficeID: DelvOffice[0].OfficeID.substr(10, 5),
        DelvCompany: DelvOffice[0].CompanyName,
        DelvOffice: DelvOffice[0].Name,
        DelvDept: "",
        DelvPIC: "",
        DelvType: "",
        DelvEmployeeID: "",
        Observation: "",

        PayCompanyID: PayOffice[0].CompanyID,
        PayOfficeID: PayOffice[0].OfficeID.substr(10, 5),
        PayCompany: PayOffice[0].CompanyName,
        PayOffice: PayOffice[0].Name,
        PayDept: "",
        PayPIC: "",
        PayEmployeeID: "",
*/
        Price: this.TotalPrice,
//        Discount: JSON.stringify(discountInfo),
        Fee: this.TotalFee,
        Status: Status,

        OrdererID: this.$store.state.employee.EmployeeID,
        OrdererCompanyName: this.$store.state.employee.CompanyName,
        OrdererOfficeName: this.$store.state.employee.OfficeName,
        OrdererName: this.$store.state.employee.Name,

        CustomerOrderNumber: this.CustomerOrderNumber,

        hasSurplus: hasSurplus,
        IssuedAt: IssuedAt,
        ValidityAt: ValidityAt
      }
//      application["CustomRepName"] = "01"

      try {
//          console.log("this.selectedSamples", this.selectedSamples)
          let applicationDialogIF = {}

          let sampleid = 0
          for (const item of this.selectedSamples) {
              let oilUsageTime = null
              if((item.OilUsageTime != null) && (item.OilUsageTime != "")){
                oilUsageTime = item.OilUsageTime
              }

              let mountedMachine = {}
              if(item.mountedMachine != null) {
                mountedMachine = item.mountedMachine
              }

              let sample = {
                id: item.id,
                OfficeID: this.$store.state.operatingOffice.OfficeID,
                SamplingAt: item.SamplingAt,
                Name: item.Name,
                CustomerMachineID: item.CustomerMachineID,
                MachineID: item.MachineID,
                MakerID: item.MakerID,
                ModelNumber: item.ModelNumber,
                PurchasedDate: "",
                SystemOil: null,
                SystemOilUnit: "",
                SystemOilUnitText: "",
                MachineMemo: "",
                OperatingTime: oilUsageTime,
                OperatingTimeUnit: item.OilUsageTimeUnit,
                OperatingTimeUnitText: item.OilUsageTimeUnitText,
                TotalOperatingTime: null,
                TotalOperatingTimeUnit: "",
                TotalOperatingTimeUnitText: "",
                OilmakerID: item.OilmakerID,
                OilModelNumber: item.OilModelNumber,
                OilTypeCategory: item.OilTypeCategory,
                OilTypeCategoryText: item.OilTypeCategoryText,
                OilType: item.OilType,
                OilTypeText: item.OilTypeText,
                isHazardousMaterials: item.isHazardousMaterials,
                HazardousMaterialsDetail: item.HazardousMaterialsDetail,
                OilChangeDate: "",
                OilChange: null,
                OilChangeUnit: "",
                OilChangeUnitText: "",
                OilUsageTime: oilUsageTime,
                OilUsageTimeUnit: item.OilUsageTimeUnit,
                OilUsageTimeUnitText: item.OilUsageTimeUnitText,
                AnalizeTypeGroup: item.AnalizeTypeGroup,
                AnalizeTypeGroupName: item.AnalizeTypeGroupName,
                AnalizeType: item.AnalizeType,
                AnalizeTypeName: item.AnalizeTypeName,
                AnalizeSet: item.AnalizeSet,
                AnalizeSetName: item.AnalizeSetName,
                AnalizeItems: JSON.stringify(item.AnalizeItems),
                AnalizeItemNames: JSON.stringify(item.AnalizeItemNames),
                AnalizeItemSub: JSON.stringify(item.AnalizeItemSub),
                StandardValue: "0",
                StandardValueName: "",
                Surplus: item.Surplus,
                Filter: item.Filter,
                LatestOrderNumber: item.LatestOrderNumber,
                ApplicationID: uuid,
                Memo: item.Memo,
                Message: item.Message,
                SamplingBy: "",
                BottleCount: 1,
                Price: item.Price,
                Fee: item.Fee,
                Discount: item.Discount,
                Tax: 0,
                Quantity: item.Require,
                SameCount: item.SameCount,
                HazardousMaterialsConfirmed: "",
                TrackingNumber: item.CustomerMachineID,
                Opinion: item.Opinion,
                Status: item.Status,

//                ParentCustomerMachineID: mountedMachine.Name, //注：機体番号はマイ機器名（Name）に入っている（機体はマイ機器IDはなし）
                ParentCustomerMachineID: item.MachineName,
                ParentEquipment: mountedMachine.Equipment,
                ParentMakerID: mountedMachine.MakerID,
                ParentMakerText: mountedMachine.MakerText,
                ParentModelNumber: mountedMachine.ModelNumber,
                ParentPurchasedDate: mountedMachine.PurchasedDate,
                ParentTotalOperatingTime: mountedMachine.TotalOperatingTime,
                ParentTotalOperatingTimeUnit: mountedMachine.TotalOperatingTimeUnit,
                ParentTotalOperatingTimeUnitText: mountedMachine.TotalOperatingTimeUnitText,
                ParentSinceOverhaulTime: mountedMachine.SinceOverhaulTime,
                ParentSinceOverhaulTimeUnit: mountedMachine.SinceOverhaulTimeUnit,
                ParentSinceOverhaulTimeUnitText: mountedMachine.SinceOverhaulTimeUnitText,

              }

/*
              //サンプル毎のステータスを設定
              if(item.Opinion) {
                sample["Status"] = "quoteRequest"
              }else {
                sample["Status"] = "quoteIssued"
              }
*/

              if(this.isCreate){
                sampleid = sampleid + 1
                sample["SampleID"] = ('0000000000' + sampleid).slice(-8)
                console.log('insert sample', sample)
                const registeredSample = await API.graphql(graphqlOperation(createSample, {input: sample}))
                console.log('insert success', registeredSample)
              }else {
                if(item.insert){
                  sampleid = sampleid + 1
                  sample["SampleID"] = ('0000000000' + sampleid).slice(-8)
                  console.log('add sample', sample)
                  const registeredSample = await API.graphql(graphqlOperation(createSample, {input: sample}))
                  console.log('add sample success', registeredSample)
                }else if(item.delete){
                  console.log('delete sample', sample)
                  let _sample = {
                    id: sample.id,
                  }
                  const deletedSample = await API.graphql(graphqlOperation(deleteSample, {input: _sample}))
                  console.log('delete sample success', deletedSample)
                }else if(item.update) {
                  sampleid = sampleid + 1
                  sample["SampleID"] = ('0000000000' + sampleid).slice(-8)
                  console.log('update sample', sample)
                  const updatedSample = await API.graphql(graphqlOperation(updateSample, {input: sample}))
                  console.log('update success', updatedSample)
                }else { //変更なしの場合はサンプルIDのみ更新（削除/追加によってサンプルIDに欠番が出るため
                  sampleid = sampleid + 1
                  let _sample = {
                    id: sample.id,
                    SampleID: ('0000000000' + sampleid).slice(-8)
                  }
                  console.log('update sample', sample)
                  const updatedSample = await API.graphql(graphqlOperation(updateSample, {input: _sample}))
                  console.log('update success', updatedSample)
                }
              }
/*
              if(item.isHazardousMaterials == "1") {
                applicationDialogIF["hasHazardousMaterials"] = true
              }
*/
          }
          this.progressMessages.splice( 0, 1, {"status":1, "message":"サンプルの登録完了（" + sampleid + "サンプル）"});

          application["SampleCount"] = sampleid

          if((Status == "quoteIssued") || (Status == "quoteReturn")) {
            let discountInfo = {"code":"", "discount":0}

            // 見積を登録するとき
            // Web割引対象の企業の場合、Web割引情報を取得する。
            // 割引適用の場合、見積の有効期限は割引の終了日で上書き
            console.log("ValidityAt before", application.ValidityAt)
            if(this.isDiscountCompany()){ 
              discountInfo = await this.getDiscount(this.TotalFee)
              if(discountInfo.code != "") {
                if(discountInfo.To <= application.ValidityAt) {
                  application["ValidityAt"] = discountInfo.To
                  console.log("ValidityAt after", application.ValidityAt)
                }
              }
            }
            console.log("analize fee discountInfo", discountInfo)
            application["Discount"] = JSON.stringify(discountInfo)
          }

          if(this.isCreate) {
            console.log("insert application", application)
            application["sortKey"] = new Date().toISOString()
            const registeredApplication = await API.graphql(graphqlOperation(createApplication, {input: application}))
            console.log('success', registeredApplication)
          }else {
            // 見積の更新及びスタッフによる回答時は依頼者は更新しない
            delete application['OrdererID'];
            delete application['OrdererCompanyName'];
            delete application['OrdererOfficeName'];
            delete application['OrdererName'];

            console.log("update application", application)
            const registeredApplication = await API.graphql(graphqlOperation(updateApplication, {input: application}))
            console.log('success', registeredApplication)
          }
          this.progressMessages.splice( 1, 1, {"status":1, "message":"お見積りの登録完了"});

          this.reset()
          // this.isSuccessed = true
          window.removeEventListener("beforeunload", this.handler)
          this.isPageMove=false
          this.$refs.isLoading.end();

          // 完了画面（スタッフとクライアントで振り分け）
          if(!this.$store.state.isStaff) {
            applicationDialogIF["id"] = uuid
            if(this.OpinionCount > 0) {
              applicationDialogIF["hasOpinion"] = true
            }else {
              applicationDialogIF["hasOpinion"] = false
              this.hasOpinion = false
            }
            this.successUrl = '/'
            this.successText = 'お見積り依頼を登録しました。'
            this.$refs.isSuccessed.open(applicationDialogIF);
          }else {
            applicationDialogIF["id"] = uuid
            if(this.OpinionCount != this.AnsweredCount) {
              applicationDialogIF["hasOpinion"] = true
            }else {
              applicationDialogIF["hasOpinion"] = false
              this.hasOpinion = false
            }
            this.successUrl = '/staffpage'
            this.successText = 'お見積り依頼を更新しました。'
            this.$refs.isSuccessed4Staff.open(applicationDialogIF);
          }

        // this.$router.push('/')
      } catch (error) {
          console.log('error: ', error)
          this.processing = false
          this.$refs.isLoading.end();
          this.$refs.isFailured.open();
      }
    },

    searchMachine : async function (OfficeID) {
      this.loading = true

      let analizeType = ""
      if(this.AnalizeTypeCategory == "一般") {
        analizeType = "1"
      }else {
        analizeType = "2"
      }

      let typeFilter = {
        and: [
        {
          AnalizeType:{ beginsWith: analizeType }
        },  
        {
          or: [
            {
              Type:{contains: "装備装置"}
            },
            {
              Type:{attributeExists: false}
            },
          ]
        }
        ]
      }
      let machines = await fetchAllMachineByOffice(OfficeID, typeFilter)
      this.machines = machines;
      console.log("searchMachine:", this.machines)

      this.aircrafts = []
      typeFilter = {
        and: [
          {
            AnalizeType:{ beginsWith: analizeType }
          },  
          {
            Type:{contains: "機体"}
          }
        ]
      }
      let _aircrafts = await fetchAllMachineByOffice(OfficeID, typeFilter)
      this.aircrafts = _aircrafts;
      console.log("aircrafts:", this.aircrafts)
      
      
      this.loading = false
    },
    changeFilter: async function (selecteditem) {
      this.calcFilterFee(selecteditem)
    },
    changeSurplus: async function(selecteditem) {
      this.calcSurplus(selecteditem)
    },
    changeOilTypeCategory: async function() {
      const oilTypeCategorys = this.oilTypeCategoryList.filter(item => item.Value  == this.OilTypeCategory)
      this.OilTypeCategoryText = oilTypeCategorys[0].Text
      // オイルの種類のリストを更新
      this.OilTypeList = await this.getOilTypeList(this.OilTypeCategory + this.AnalizeTypeCategory)
      console.log("changeOilTypeCategory this.OilTypeList", this.OilTypeList)
      console.log("changeOilTypeCategory this.AnalizeTypeGroup", this.AnalizeTypeGroup)

      // 分析方法が選択済みの場合、分析区分を自動設定
      // 合わせて、セット分析のリスト、個別分析項目のリストを更新
      if(this.AnalizeTypeGroup) {
        const analizeTypeGroup = this.analizeTypeGroupList.filter(item => item.Value  == this.AnalizeTypeGroup)
        console.log("changeOilTypeCategory analizeTypeGroup", analizeTypeGroup)
        this.AnalizeType = String(Number(analizeTypeGroup[0].Code) + Number(this.OilTypeCategory))

        await this.changeAnalizeType()
      }
    },
    changeOilType: async function() {
      const oilType = this.OilTypeList.filter(item => item.Value  == this.OilType)
      this.OilTypeText = oilType[0].Text
      this.isHazardousMaterials = oilType[0].isHazardousMaterials
      this.isAccept = oilType[0].isAccept
      if(oilType[0].Properties == "true") {
        this.hasOilProperties = true
      }else {
        this.hasOilProperties = false
      }
      this.OilProperty = ""
      this.OilPropertyText = ""

      // 危険物が含まれる場合は相談必須
      if (this.isOpinionRequired(oilType[0].isHazardousMaterials, oilType[0].isAccept)){
//        console.log("this oil is opinion", this.getNoticeType)
        if(this.$store.state.isStaff == false) {
          this.isOpinionDisabled = true
          this.Opinion = true
        }else {
          this.isOpinionDisabled = false
          this.Opinion = false
        }
      }else {
//        console.log("this oil is N O T opinion", this.getNoticeType)
        this.isOpinionDisabled = false
        this.Opinion = false
      }
    },
    changeOilProperty: async function() {
      const oilProperty = this.OilPropertyList.filter(item => item.Value  == this.OilProperty)
      this.OilPropertyText = oilProperty[0].Text
    },    
    changeAnalizeTypeGroup: async function() {
        this.isSelectAnalizeSet = false
        const typeGroup = this.analizeTypeGroupList.filter(item => item.Value  == this.AnalizeTypeGroup)
        this.analizeTypeList = await this.getAnalizeTypeList(this.AnalizeTypeGroup)
        this.AnalizeTypeGroupName = typeGroup[0].Text

        if(this.OilTypeCategory){
          this.AnalizeType = String(Number(typeGroup[0].Code) + Number(this.OilTypeCategory))
          this.changeAnalizeType()
        }
    },
    changeAnalizeType: async function () {
        this.isSelectAnalizeSet = false
        this.analizeSetList = await this.getAnalizeSetList(this.AnalizeType)
        this.analizeItemList = await this.getAnalizeItemList(this.AnalizeType)
        this.activeAnalizeItemList = this.analizeItemList
        this.analizeItemSubList = await this.getAnalizeItemSubList(this.AnalizeType)

/* 一旦削除！
        const standardvaluelist = this.$store.state.standardValueList.filter(item => item.AnalizeType  == this.AnalizeType)
        this.standardValueList = standardvaluelist[0].standardValues
*/

        this.AnalizeSet = ""
        this.AnalizeSetName = ""
        this.AnalizeItems = ""
        this.AnalizeItemSub = {}
        this.StandardValue = ""
        this.StandardValueName = ""

        this.Price = 0
        this.Fee = 0
        this.SetPrice = 0
        this.Require = 0
        this.SetRequire = 0

        const AnalizeTypeName = this.analizeTypeList.filter(item => item.Value  == this.AnalizeType)
        this.AnalizeTypeName = AnalizeTypeName[0].Text
    },
    changeAnalizeSet: async function () {
        this.isSelectAnalizeSet = false
        if (this.AnalizeSet) {
          // セットが選びなおされた場合、個別分析項目をリセットする（セットと重複することがあるため）
          this.AnalizeItems = []
          this.AnalizeItemSub = {}

          const AnalizeSetName = this.analizeSetList.filter(item => item.Value  == this.AnalizeSet)
          this.AnalizeSetName = AnalizeSetName[0].Text
          this.analizeSetItems = []
//            this.includeItem()
          this.activeAnalizeItemList = await this.excludeAnalizeItems(AnalizeSetName[0].AnalizeItems, this.analizeItemList)

          this.analizeSetItems = await this.getAnalizeSetItems(AnalizeSetName[0])
          this.isSelectAnalizeSet = true

          this.SetPrice = AnalizeSetName[0].Price
          this.SetRequire = AnalizeSetName[0].Require
          this.Price = this.SetPrice
          this.Fee = this.SetPrice
          this.Require = this.SetRequire
        } else {
          this.activeAnalizeItemList = this.analizeItemList
          this.AnalizeSet = ""
          this.AnalizeSetName = ""
          this.analizeSetItems = []

          this.Price = this.Price - this.SetPrice
          this.Fee = this.Fee - this.SetPrice
          this.Require = this.Require - this.SetRequire
          this.SetPrice = 0
          this.SetRequire = 0
//          this.AnalizeItemsInclude = []
//          this.analizeItemListInclude = []
          this.analizeSetItems = []
        }
        this.consolelogPrice()
        await this.changeAnalizeItems(this.AnalizeItems)
        // セット分析の選択・解除に伴い、個別分析項目のバリデーションを再評価させる
        // （初期表示直後はまだ未touchのため、セットを✕で消してもチェックが動かない対策）
        this.$v.AnalizeItems.$touch()
    },
    changeAnalizeItems: async function (selecteditems) {
/*
      this.Price = this.SetPrice
      this.Fee = this.SetPrice
      this.Require = this.SetRequire
      for (var selecteditem of selecteditems) {
        let itemlist = this.analizeItemList.filter(item => item.Value  == selecteditem)
        this.calcAnalizeItemPrice(itemlist[0])
        this.Require = this.Require + Number(itemlist[0].Require)
      }
      this.consolelogPrice()
*/
        for (var parentItem of Object.keys(this.analizeItemSubList)) {
          if(selecteditems.includes(parentItem)) {
            // サブ項目がある分析項目がえらばれている場合は配列をセット（継続）
            let selectedSub = this.AnalizeItemSub[parentItem]
            if(selectedSub == undefined) {
              selectedSub = []
            }
            this.AnalizeItemSub[parentItem] = selectedSub
          }else {
            const includeSet = this.analizeSetItems.filter(item => item.Value  == parentItem)
            if(!includeSet[0]) {
              // サブ項目がある分析項目が選ばれていなかった且つ、セットにも含まれていない場合は削除（リセット）
              delete this.AnalizeItemSub[parentItem]
            }else {
              let selectedSub = this.AnalizeItemSub[parentItem]
              if(selectedSub == undefined) {
                selectedSub = []
              }
              this.$set(this.AnalizeItemSub, parentItem, selectedSub);
            }
          }
        }

        this.calcAnalizeItemPriceAll()
    },
    changeAnalizeItemSub: async function() {
      this.calcAnalizeItemPriceAll()

      // 強制的に個別分析項目のvalidationを実行させるために値を一次的に変更
      //値が変わらないとtouchが実行されない=validationsが実行されない        
      this.AnalizeItems.push("dummy")
      this.AnalizeItems.pop("dummy")
      this.$v.AnalizeItems.$touch()
    },
    calcAnalizeItemPriceAll: function() {
      this.Price = this.SetPrice
      this.Fee = this.SetPrice
      this.Require = this.SetRequire

      for (var selecteditem of this.AnalizeItems) {
        let itemlist = this.analizeItemList.filter(item => item.Value  == selecteditem)
        this.calcAnalizeItemPrice(itemlist[0])
        this.Require = this.Require + Number(itemlist[0].Require)
      }

      if(this.AnalizeItemSub) {
        for (var parentItem of Object.keys(this.AnalizeItemSub)) {
            let _analizeItemSubList = this.analizeItemSubList[parentItem]
            for (var selecteditemsub of this.AnalizeItemSub[parentItem]) {
              let itemlist = _analizeItemSubList.filter(item => item.Value  == selecteditemsub)
              this.calcAnalizeItemPrice(itemlist[0])
              this.Require = this.Require + Number(itemlist[0].Require)
            }
          }
      }
    },
    calcAnalizeItemPrice: function(item) {
/*
      let price = Number(item.Price)
      let regularPrice = Number(item.RegularPrice)
      let fee = price
      // 定価が定義されていない=得意先ホルダで上書きされていない場合
      // 得意先の掛け率で割掛け
      // 得意先ホルダで値引かれている場合は割かけ市内
      if(!regularPrice) {
        switch (this.Rounding){
          case "切捨":
            fee = Math.floor(price * this.Ratio)
            break
          case "四捨五入": // ラミネート加工 1700円
            fee = Math.round(price * this.Ratio)
            break
          default: //"切上"
            fee = Math.ceil(price * this.Ratio)
            break
        }
      }
*/
      let price = Number(item.Price)
      let fee = this.getAnalizeItemFee(item,this.Ratio,this.Rounding)
      let discount = price - fee

      this.Price = this.Price + price
      this.Fee = this.Fee + fee
      this.Discount = this.Discount + discount
      this.consolelogPrice()
    },
    calcFilterFee: function(filter) {
      this.FilterFee = this.getFilterFee(filter)
/*
      switch (filter) {
        case "003": // ラミネート加工なし 600円
          this.FilterFee = 600;
          break
        case "002": // ラミネート加工 1700円
          this.FilterFee = 1700;
          break
        default: // case 001 なし
          this.FilterFee = 0;
          break
      }
*/
      this.consolelogPrice()
    },
    calcSurplus: function(surplus) {
      // 残サンプル返却料金はサンプル毎には取らないので0円加算
      // 返却手数料は依頼毎に1800円（サンプル数によらず）
      let surplusFee = this.getSurplusFee(surplus)
      surplusFee = 0
      this.Price = this.Price + surplusFee
      this.Fee = this.Fee + surplusFee
/*
      switch (surplus) {
        case "1": // 希望
          this.Price = this.Price + 0
          this.Fee = this.Fee + 0
          break
        default: // case "0" 希望しない
          this.Price = this.Price + 0
          this.Fee = this.Fee + 0
          break
      }
*/
      this.consolelogPrice()
    },
    getAnalizeItemName(analizeItem) {
      let item = this.analizeItemList.filter(item => item.Value  == analizeItem)
      return item[0].Text

    },      
    consolelogPrice() {
/*
      let pricelog = {
        SetPrice: this.SetPrice,
        SetRequire: this.SetRequire,
        Price: this.Price,
        Fee: this.Fee,
        Require: this.Require,
        FilterFee: this.FilterFee,
        Discount: this.Discount,
      }
      console.log("price log", pricelog)
*/
    }
  },
  created () {
    window.addEventListener("beforeunload", this.handler)
  },
  destroyed () {
    window.removeEventListener("beforeunload", this.handler)
  }      
}
</script>
<style scoped>
.agree-text /deep/ label {
    color: black;
}
</style>
<style scoped>
.v-data-table__expanded.v-data-table__expanded__content {
  box-shadow: none !important;
  background-color:rgb(235, 232, 232)
}
.cart-list {
  height: 75vh;
  overflow-y: auto;
}
.label-chip {
  margin-right : 10px;
  margin-bottom : 3px;
  width: 90px;
}
.wrap-text {
  overflow-wrap: break-all;
  word-break: break-all;
  white-space: pre-line;
}
</style>
